<!-- LOGIN PAGE -->
<div *ngIf="isLogIn" [ngClass]="deviceType === 'mobile' ? 'loginContainer' : 'loginContainerDesktop'"
  (keyup.enter)="stablelogin()">
  <img class="login__img" src="../../../../../assets/img/illustration_login_v6.svg"
    alt="Hotelier waving and welcoming people to Vervendo">
  <div class="login__section">
    <div *ngIf="deviceType === 'desktop'" class="social">
      <button (click)="socialSignIn('google')" class="social__button"><img class="social__icon"
          src="../../../../../assets/img/icons/google_icon.svg" alt="Google Logo"><span class="social__text">Connect
          with
          Google</span></button>
      <button (click)="socialSignIn('facebook')" class="social__button"><img class="social__icon"
          src="../../../../../assets/img/icons/facebook_icon.svg" alt="Facebook Logo"><span class="social__text">Connect
          with
          Facebook</span></button>
    </div>
    <span *ngIf="deviceType === 'desktop'" class="alternativeSignUp">Or login via</span>
    <div class="login__container">
      <div class="credsContainer">
        <div class="emailInput">
          <input autocomplete="on" [(ngModel)]="userEmail" type="email" placeholder="Email">
        </div>
        <hr>
        <div class="passwdInput">
          <input autocomplete="on" id="passl" [(ngModel)]="userPasswd" type="password" placeholder="Password">
          <div class="showPasswordContainer">
            <span>Show password</span><input type="checkbox" class="showPassword" (click)="showPassword()">
          </div>
        </div>
        <div style="text-align: center;">
          <button type="submit" class="button__login" (click)="stablelogin()">Login</button>
        </div>
      </div>
    </div>
    <div class="forgotPass">
      <p><a (click)="forgotBtn()">Forgot your password?</a></p>
    </div>
    <p  *ngIf="deviceType === 'desktop'" class="ahaLogin">Don't have an account? <a (click)="signUpRBtn()">Sign Up</a></p>
    <div id="privacyMsg">
      <p>We respect your privacy and protect it very seriously.</p>
    </div>
  </div>
</div>



<!-- SIGN UP PAGE -->
<div *ngIf="isSignUp && deviceType === 'desktop'" [ngClass]="deviceType === 'mobile' ? 'signUpContainer' : 'signUpContainerDesktop'"
  (keyup.enter)="signUpStableInit()">
  <div class="signup__container">
    <svg version="1.1" class="signup__image" id="browse_phone" xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 118.7 212.9"
      style="enable-background:new 0 0 118.7 212.9;" xml:space="preserve">
      <style type="text/css">
        .browse-st0 {
          fill: #F3B191;
        }

        .browse-st1 {
          fill: #FFCDB6;
        }

        .browse-st2 {
          fill: #E38D76;
        }

        .browse-st3 {
          fill: #DF8B73;
        }

        .browse-st4 {
          fill: #0D4870;
        }

        .browse-st5 {
          fill: #FFFFFF;
        }

        .browse-st6 {
          fill: #0A3959;
        }

        .browse-st7 {
          fill: #457FB3;
        }

        .browse-st8 {
          fill: #8FCEF6;
        }

        .browse-st9 {
          fill: #3473AC;
        }

        .browse-st10 {
          clip-path: url(#browse-clip-path_1_);
        }

        .browse-st11 {
          fill: #2C6DA9;
        }

        .browse-st12 {
          fill: #74D13B;
        }

        .browse-st13 {
          fill: #FC496F;
        }

        .browse-st14 {
          fill: none;
          stroke: #FFFFFF;
          stroke-width: 0.4885;
          stroke-linecap: round;
          stroke-linejoin: round;
          stroke-miterlimit: 10;
        }

        .browse-st15 {
          fill: #FEB6C5;
        }

        .browse-st16 {
          fill: #FBB03B;
        }

        .browse-st17 {
          fill: none;
          stroke: #FFFFFF;
          stroke-width: 0.3647;
          stroke-linecap: round;
          stroke-linejoin: round;
          stroke-miterlimit: 10;
        }

        .browse-st18 {
          fill: #FABC2A;
        }

        .browse-st19 {
          fill: #FFF94E;
        }

        .browse-st20 {
          opacity: 0.25;
        }

        .browse-st21 {
          fill: #FF577F;
        }
      </style>
      <path class="browse-st0" d="M107.7,102.5c-0.2-0.1-0.5-0.2-0.8-0.3C107.1,102.3,107.4,102.4,107.7,102.5z" />
      <path class="browse-st0" d="M25.2,155.9c2.5,6.2,1.6,18.1,1.6,18.1l42,18.1c-0.1-1.2,4.2-6.1,8.9-10.9c5-5.1,10.3-10.1,11.3-10.5l0.5-3
   l0.6-3.7l10.7-63.9l3.6,1.3l2.3,0.8l0.2,0.1c7.5-6.8,11-12.4,8.4-16c-2-2.3-4.5-3.5-8.6-1.1c-0.1,0-0.1,0.1-0.2,0.1l-2.1,0.3
   l-31.8,5l-5.2,0.8l-26,4.1l-1.7,0.3l-0.1,0c-0.4-3.8-2.1-6.6-5.7-6.1c-3.2,0.5-4.3,2.4-4.3,6.1l-1.5,13.4
   c-2.7,12.2-6.5,22.2-6.6,29.5C21.5,138.8,22.8,149.7,25.2,155.9z" />
      <path class="browse-st1" d="M30.7,92.3c1.4-0.5,2.3-0.1,2.9,0.8c0.4,0.6,0.5,1.2,0.5,1.9c0,2.5-0.4,4.8-1.2,6.8c-0.3,0.8-0.8,1.5-1.5,2
   c-0.6,0.4-1.2,0.6-2.2,0.5L30.7,92.3z" />
      <path class="browse-st2" d="M39.7,93.7c0,0-3.2,64.7-3.2,71.2c0,7.8,8.5,9.9,16.3,10.3s22.9,0.3,30.8,0.1c2-2,4.5-4.2,5.4-4.6l0.5-3
   L39.7,93.7z" />
      <path class="browse-st3" d="M106.7,102.2v7.8c2.1-3,3.7-6.1,1.1-7.4c-0.3-0.1-0.6-0.2-0.8-0.3L106.7,102.2z" />
      <path class="browse-st4"
        d="M39.7,59.6v102c0,5,4.1,9,9,9h48.9c5,0,9-4.1,9-9v-102c0-5-4.1-9-9-9H48.7C43.7,50.6,39.7,54.6,39.7,59.6z" />
      <path class="browse-st5" d="M45.1,163.9h55.5c2.1,0,3.7-1.7,3.7-3.7V62c0-2.1-1.7-3.7-3.7-3.7H45.1c-2.1,0-3.7,1.7-3.7,3.7v98.2
   C41.4,162.3,43.1,163.9,45.1,163.9z" />
      <circle class="browse-st6" cx="83.2" cy="54.5" r="1.3" />
      <circle class="browse-st6" cx="63.1" cy="54.5" r="1.3" />
      <path class="browse-st6" d="M67.3,55.8h11.5c0.7,0,1.3-0.6,1.3-1.3l0,0c0-0.7-0.6-1.3-1.3-1.3H67.3c-0.7,0-1.3,0.6-1.3,1.3l0,0
   C66,55.2,66.6,55.8,67.3,55.8z" />
      <path class="browse-st6" d="M67.6,169.4h11.3c1,0,1.9-0.8,1.9-1.9v-0.1c0-1-0.8-1.9-1.9-1.9H67.6c-1,0-1.9,0.8-1.9,1.9v0.1
   C65.7,168.6,66.6,169.4,67.6,169.4z" />
      <path class="browse-st7"
        d="M70.1,212.9l2.6-6.8c1.1-2.9-0.3-6.1-3.1-7.2l-49.7-20.2c-2.9-1.2-6.2,0.2-7.4,3.1L0,212.9H70.1z" />
      <path class="browse-st8"
        d="M70.4,199.3l0.8-1.9c1-2.3-0.1-4.9-2.4-5.9l-41.4-17.8c-2.2-1-4.8,0-5.9,2.2l-1.4,2.9L70.4,199.3z" />
      <circle class="browse-st9" cx="64.9" cy="205.5" r="3.5" />
      <g>
        <defs>
          <path id="browse-clip-path" d="M45.1,163.9h55.5c2.1,0,3.7-1.7,3.7-3.7V62c0-2.1-1.7-3.7-3.7-3.7H45.1c-2.1,0-3.7,1.7-3.7,3.7
       v98.2C41.4,162.3,43.1,163.9,45.1,163.9z" />
        </defs>
        <clipPath id="browse-clip-path_1_">
          <use xlink:href="#browse-clip-path" style="overflow:visible;" />
        </clipPath>
        <g id="offers" class="browse-st10">
          <g id="offer-1">
            <g>
              <path class="browse-st11" d="M45.9,100.2c-0.8,0-1.5-0.7-1.5-1.5V63c0-0.8,0.7-1.5,1.5-1.5h54.2c0.8,0,1.5,0.7,1.5,1.5v35.6
           c0,0.8-0.7,1.5-1.5,1.5H45.9z" />
              <path class="browse-st12" d="M100.1,61.9c0.6,0,1.1,0.5,1.1,1.1v35.6c0,0.6-0.5,1.1-1.1,1.1H45.9c-0.6,0-1.1-0.5-1.1-1.1V63
           c0-0.6,0.5-1.1,1.1-1.1H100.1 M100.1,61.1H45.9c-1.1,0-1.9,0.9-1.9,1.9v35.6c0,1.1,0.9,1.9,1.9,1.9h54.2c1.1,0,1.9-0.9,1.9-1.9
           V63C102,62,101.1,61.1,100.1,61.1L100.1,61.1z" />
            </g>
            <g>
              <path class="browse-st8" d="M96.7,90.2H49.1c-0.4,0-0.7-0.3-0.7-0.7v0c0-0.4,0.3-0.7,0.7-0.7h47.5c0.4,0,0.7,0.3,0.7,0.7v0
           C97.3,89.8,97,90.2,96.7,90.2z" />
              <path class="browse-st8" d="M72.9,92.4H49.1c-0.4,0-0.7-0.3-0.7-0.7v0c0-0.4,0.3-0.7,0.7-0.7h23.8c0.4,0,0.7,0.3,0.7,0.7v0
           C73.6,92.1,73.3,92.4,72.9,92.4z" />
            </g>
            <g>
              <g>
                <rect x="75.5" y="82.5" class="browse-st13" width="2.2" height="2.2" />
                <polyline class="browse-st14" points="77.9,82.5 76.7,83.9 76.2,83.3 				" />
              </g>
              <g>
                <path class="browse-st5" d="M70.4,84.2v-1.4h0.9V83h-0.7v0.4h0.6v0.2h-0.6V84h0.7v0.2H70.4z" />
                <path class="browse-st5"
                  d="M71.4,84.2l0.5-0.7l-0.5-0.7h0.2l0.4,0.5l0.4-0.5h0.2l-0.5,0.7l0.5,0.7h-0.2l-0.4-0.5l-0.4,0.5H71.4z" />
                <path class="browse-st5" d="M72.7,84.2v-1.4h0.5c0,0,0,0,0,0c0,0,0,0,0.1,0c0.1,0,0.1,0,0.2,0.1c0,0,0.1,0.1,0.1,0.1c0,0.1,0,0.1,0,0.2
             c0,0.1,0,0.1,0,0.2c0,0.1-0.1,0.1-0.1,0.1c0,0-0.1,0.1-0.2,0.1c0,0,0,0-0.1,0c0,0,0,0,0,0h-0.4v0.5H72.7z M72.8,83.5h0.4
             c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1,0,0.1-0.1c0,0,0-0.1,0.1-0.1c0,0,0-0.1,0-0.1s0-0.1,0-0.1c0,0,0-0.1-0.1-0.1
             c0,0-0.1,0-0.1-0.1c0,0,0,0,0,0c0,0,0,0,0,0h-0.4V83.5z" />
                <path class="browse-st5" d="M74.4,84.2V83l-0.3,0.2V83l0.3-0.2h0.2v1.4H74.4z" />
              </g>
            </g>
            <g>
              <g>
                <rect x="85.2" y="82.5" class="browse-st13" width="2.2" height="2.2" />
                <polyline class="browse-st14" points="87.6,82.5 86.4,83.9 85.9,83.3 				" />
              </g>
              <g>
                <path class="browse-st5" d="M79.7,84.2v-1.4h0.9V83h-0.7v0.4h0.6v0.2h-0.6V84h0.7v0.2H79.7z" />
                <path class="browse-st5"
                  d="M80.7,84.2l0.5-0.7l-0.5-0.7h0.2l0.4,0.5l0.4-0.5h0.2l-0.5,0.7l0.5,0.7h-0.2l-0.4-0.5l-0.4,0.5H80.7z" />
                <path class="browse-st5" d="M82,84.2v-1.4h0.5c0,0,0,0,0,0c0,0,0,0,0.1,0c0.1,0,0.1,0,0.2,0.1c0,0,0.1,0.1,0.1,0.1c0,0.1,0,0.1,0,0.2
             c0,0.1,0,0.1,0,0.2c0,0.1-0.1,0.1-0.1,0.1c0,0-0.1,0.1-0.2,0.1c0,0,0,0-0.1,0c0,0,0,0,0,0h-0.4v0.5H82z M82.1,83.5h0.4
             c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1,0,0.1-0.1c0,0,0-0.1,0.1-0.1c0,0,0-0.1,0-0.1s0-0.1,0-0.1c0,0,0-0.1-0.1-0.1
             c0,0-0.1,0-0.1-0.1c0,0,0,0,0,0c0,0,0,0,0,0h-0.4V83.5z" />
                <path class="browse-st5" d="M83.5,84.2l0-0.2l0.6-0.5c0.1,0,0.1-0.1,0.1-0.1c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.1c0,0-0.1-0.1-0.1-0.1
             s-0.1,0-0.1,0c-0.1,0-0.1,0-0.1,0c0,0-0.1,0.1-0.1,0.1c0,0,0,0.1,0,0.1h-0.2c0-0.1,0-0.2,0.1-0.2c0-0.1,0.1-0.1,0.2-0.2
             c0.1,0,0.1-0.1,0.2-0.1c0.1,0,0.2,0,0.2,0.1c0.1,0,0.1,0.1,0.2,0.2c0,0.1,0.1,0.1,0.1,0.2c0,0.1,0,0.1,0,0.2c0,0,0,0.1-0.1,0.1
             s-0.1,0.1-0.1,0.1l-0.5,0.4l0-0.1h0.7v0.2H83.5z" />
              </g>
            </g>
            <g>
              <g>
                <rect x="94.8" y="82.5" class="browse-st13" width="2.2" height="2.2" />
                <polyline class="browse-st14" points="97.2,82.5 96,83.9 95.5,83.3 				" />
              </g>
              <g>
                <path class="browse-st5" d="M89.4,84.2v-1.4h0.9V83h-0.7v0.4h0.6v0.2h-0.6V84h0.7v0.2H89.4z" />
                <path class="browse-st5"
                  d="M90.4,84.2l0.5-0.7l-0.5-0.7h0.2l0.4,0.5l0.4-0.5h0.2L91,83.5l0.5,0.7h-0.2l-0.4-0.5l-0.4,0.5H90.4z" />
                <path class="browse-st5" d="M91.7,84.2v-1.4h0.5c0,0,0,0,0,0c0,0,0,0,0.1,0c0.1,0,0.1,0,0.2,0.1c0,0,0.1,0.1,0.1,0.1c0,0.1,0,0.1,0,0.2
             c0,0.1,0,0.1,0,0.2c0,0.1-0.1,0.1-0.1,0.1c0,0-0.1,0.1-0.2,0.1c0,0,0,0-0.1,0c0,0,0,0,0,0h-0.4v0.5H91.7z M91.8,83.5h0.4
             c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1,0,0.1-0.1c0,0,0-0.1,0.1-0.1c0,0,0-0.1,0-0.1s0-0.1,0-0.1c0,0,0-0.1-0.1-0.1
             c0,0-0.1,0-0.1-0.1c0,0,0,0,0,0c0,0,0,0,0,0h-0.4V83.5z" />
                <path class="browse-st5" d="M93.6,84.2c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1-0.1-0.1-0.1c0,0-0.1-0.1-0.1-0.2l0.2,0c0,0.1,0.1,0.1,0.1,0.1
             s0.1,0,0.2,0c0.1,0,0.1,0,0.1,0c0,0,0.1-0.1,0.1-0.1c0,0,0-0.1,0-0.1c0-0.1,0-0.2-0.1-0.2c-0.1-0.1-0.1-0.1-0.2-0.1
             c0,0,0,0-0.1,0c0,0,0,0-0.1,0l-0.1-0.1l0.5-0.5l0,0.1h-0.7v-0.2H94V83l-0.4,0.4l0-0.1c0.1,0,0.2,0,0.2,0c0.1,0,0.1,0.1,0.2,0.2
             c0,0.1,0.1,0.1,0.1,0.2c0,0.1,0,0.2-0.1,0.2c0,0.1-0.1,0.1-0.2,0.2C93.7,84.2,93.6,84.2,93.6,84.2z" />
              </g>
            </g>
            <g>
              <g>
                <g>
                  <path class="browse-st12" d="M51.6,68.4c2.8,4.7,3.8,8.2,4.3,11.7c0,0.3,0.8,0.2,0.7-0.1c-1-4.6-2.2-7.9-4.8-11.8
               C51.7,68.1,51.6,68.3,51.6,68.4z" />
                </g>
                <g>
                  <path class="browse-st12" d="M63.8,68.1c-0.1,3.6-1.2,12.5-1.3,16.7c0,0.3,0.8,0.4,0.8,0.1c0.1-4.2,0.6-12.6,0.8-16.8
               C64.1,67.9,63.8,67.9,63.8,68.1z" />
                </g>
                <g>
                  <path class="browse-st12" d="M53.6,68.5c-0.4-0.2-1.2-0.3-1.7-0.2c0.2-0.1,0.5-0.2,0.8-0.3l0.1-0.2l0.1,0.2c0.1,0,0.3-0.1,0.4-0.1
               l0.1-0.2l0.1,0.2c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0l0-0.2l0.1,0.2c0.5,0,0.7,0.1,1.1,0.4c-0.2-0.5-0.7-1.1-1.6-1.1
               c-0.6,0-1.2,0.7-1.5,1.1c0.2-0.4,0.6-1.2,0.9-1.4c0.6-0.4,1.3-0.5,1.9-0.5c-0.5-0.3-1.4-0.7-2.5-0.1c-0.5,0.2-0.5,1.2-0.5,1.8
               c-0.1-0.4-0.2-1-0.1-1.3c0.1-0.7,0.3-0.9,0.7-1.1c-0.2,0-1.1-0.4-1.5,0.8c-0.2,0.6,0.3,1.3,0.7,1.7c-0.4-0.4-1.1-0.9-1.7-0.8
               c-1.3,0.2-1.3,1-1.3,1.3c0.4-0.3,0.8-0.4,1.5-0.5c0.3,0,0.8,0.1,1.2,0.2c-0.7,0-1.9,0.2-2.5,0.6C48,69.5,47.9,71,48,71.6
               c0.1-0.4,0.4-0.8,0.6-1.2l0-0.4l0.1,0.2c0.1-0.1,0.2-0.2,0.3-0.3l0-0.5l0.2,0.4c0.1-0.1,0.2-0.2,0.3-0.3l-0.1-0.5l0.3,0.4
               c0.3-0.2,0.7-0.4,1.2-0.6c-0.5,0.3-1,0.8-1.2,1.3c-0.3,0.8,0.4,1.9,0.5,2.2c0.1-0.3,0.1-0.8,0.2-1.2l-0.3-0.2l0.3,0
               c0-0.1,0.1-0.2,0.1-0.4l-0.3-0.3l0.4,0.1c0-0.1,0.1-0.2,0.1-0.3c0,0,0-0.1,0.1-0.1l-0.2-0.2l0.2,0c0.3-0.5,0.9-1.3,0.9-1.3
               c0.2,0.1,1.3,0.6,1.6,0.9c0.5,0.4,0.8,0.3,1.1,0.5C54.3,69.3,54.3,68.9,53.6,68.5z" />
                </g>
                <g>
                  <g>
                    <path class="browse-st12"
                      d="M66.6,67.2c-0.7-0.1-1.7,0.3-2.3,0.6c0.3-0.3,0.8-0.6,1-0.8c0.6-0.3,1.1-0.4,1.5-0.3
                 c-0.1-0.2-0.4-0.9-1.7-0.5c-0.6,0.2-1,1.1-1.1,1.6c0.1-0.5,0.2-1.5-0.2-1.9c-0.9-0.9-1.5-0.1-1.7,0c0.5,0,0.7,0.1,1.2,0.6
                 c0.2,0.2,0.4,0.8,0.5,1.2c-0.3-0.5-0.8-1.3-1.3-1.3c-1.2,0-1.8,0.8-2.1,1.3c0.3-0.2,0.7-0.3,1.1-0.4l0.3-0.3l-0.1,0.3
                 c0.2,0,0.3,0,0.5,0l0.3-0.3l0,0.3c0.1,0,0.2,0.1,0.4,0.1l0.2-0.2l0,0.2c0.3,0.2,0.7,0.4,0.9,0.5c-0.5-0.2-1.3-0.4-1.9-0.2
                 c-0.8,0.4-0.9,1.1-0.9,1.7c0.2-0.5,0.5-0.6,1-1c0.3-0.2,1.3-0.3,1.7-0.3c-0.4,0.2-1.1,0.6-1.4,1c-0.5,0.7-0.3,1-0.2,1.5
                 c0.2-0.3,0.5-0.4,0.7-1c0.2-0.4,0.8-1.3,1-1.5c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0.2,0.1,0.6,0.4,0.9,0.6l0.2-0.1l0,0.2
                 c0.1,0.1,0.1,0.1,0.2,0.1c0,0,0.1,0.1,0.1,0.1l0.2-0.3l0,0.4c0.1,0.1,0.2,0.1,0.2,0.2l0.2-0.2l0,0.3c0.1,0.1,0.2,0.1,0.3,0.2
                 l0.1-0.1l0,0.2c0.1,0.1,0.2,0.1,0.3,0.2c0.1-0.3,0.2-0.8-0.5-1.4c-0.4-0.4-1.1-0.6-1.6-0.6c0.3,0,0.6,0,1,0l0.1-0.2l0.1,0.3
                 c0.1,0,0.3,0,0.4,0l0.1-0.3l0.2,0.4c0,0,0.1,0,0.1,0c0.1,0,0.2,0,0.3,0l0.1-0.3l0.1,0.3c0.1,0,0.2,0,0.3,0.1l0-0.2l0.1,0.2
                 c0.2,0.1,0.3,0.2,0.6,0.3C67.8,68.1,67.6,67.4,66.6,67.2z M63.9,68.1L63.9,68.1C63.9,68.1,63.9,68.1,63.9,68.1L63.9,68.1z" />
                  </g>
                </g>
              </g>
              <path class="browse-st12" d="M60.2,86.2h7h0.5v-7.4h0.6v-0.5h-0.7l-1.3-0.5h-0.7v-3.3h0.3V74h0.3v-0.6h-0.6l-5.2-1.1H60V72h-3.9v0.2
           h-0.3l-4.9,1.1h-0.6V74h0.4v0.5h0.4v3.3h-0.9l-1.3,0.5h-0.7v0.5h0.7v7.4h0.5h6.7h0.5v0h3.1v0H60.2 M49.4,78.8h0.9v5.6l-0.9,0.4h0
           V78.8z M67.2,84.9L67.2,84.9L66,84.5v-5.6h1.2V84.9z" />
            </g>
            <rect x="85.5" y="92.5" class="browse-st13" width="11.9" height="4.5" />
            <g>
              <g>
                <path class="browse-st5" d="M88.3,95.9l-0.7-2.3H88l0.6,2l0.6-2h0.4l-0.7,2.3H88.3z" />
                <path class="browse-st5" d="M89.9,95.9v-2.3h0.4v2.3H89.9z" />
                <path class="browse-st5" d="M90.8,95.9v-2.3h1.5v0.4h-1.1v0.6h0.9v0.4h-0.9v0.7h1.1v0.4H90.8z" />
                <path class="browse-st5" d="M93.2,95.9l-0.7-2.3h0.4l0.5,1.7l0.5-1.7l0.4,0l0.5,1.7l0.5-1.7h0.4l-0.7,2.3h-0.4l-0.5-1.7l-0.5,1.7H93.2z
             " />
              </g>
            </g>
            <g id="discount-price">
              <path class="browse-st5" d="M79.5,75.1c-0.3-0.2-0.3-0.6-0.1-0.9c0.4-0.5,1.5-0.6,2,0.1c0.5,0.7-0.3,0.6,1.3,0.4
           c-0.2-0.7-0.6-1.3-1.3-1.6c-0.7-0.3-0.5,0.1-0.5-1H80v0.8c-2.1,0.3-2.4,2.8-0.4,3.4c1.6,0.5,1.8,0.5,2.1,0.8
           c0.2,0.3,0.3,0.8-0.2,1.1c-0.7,0.5-2.1,0.3-2.4-0.9l-1,0.2c0.1,0.8,0.6,1.4,1.3,1.8c0.8,0.4,0.6-0.2,0.6,1H81v-0.8
           c2-0.3,2.2-2.2,1.5-3C81.8,75.6,80.1,75.6,79.5,75.1z" />
              <path class="browse-st5" d="M87.2,76.3c0.8-0.9,0.6-2.5-0.5-3.2c-1.3-0.7-3.3,0-3.3,1.8c1.6,0,0.8,0.1,1.2-0.5c0.7-1.2,2.6-0.3,1.9,1
           c-0.2,0.3-0.3,0.4-3.2,3v0.9h4.4v-1h-2.7C86.7,76.8,86.9,76.6,87.2,76.3z" />
              <path class="browse-st5" d="M88.2,75c0,1.6,1.6,2.5,2.8,1.9c0.6-0.3,0.5-0.6,0.5,0.3c0,0.9-0.9,1.5-1.7,1.1c-0.6-0.3-0.1-0.6-1.2,0.4
           c0.9,1,3,0.9,3.7-0.4c0.4-0.7,0.3-1.2,0.3-3.2C92.6,72.1,88.2,72.2,88.2,75z M91,76c-0.7,0.4-1.7-0.1-1.7-1c0-0.9,1-1.4,1.7-1
           C91.7,74.5,91.7,75.6,91,76z" />
              <path class="browse-st5" d="M97.3,76.3c-0.6-1.1-1.9-1.2-2.8-0.7l0.1-1.6h2.5v-1h-3.4l-0.2,3.4l0.9,0.3c0.5-0.5,1.5-0.6,1.9,0.1
           c0.7,1.1-0.9,2.3-1.8,1.3c-0.5-0.5,0.2-0.6-1.2-0.2c0.4,1.4,1.9,2,3.2,1.3C97.6,78.6,97.9,77.2,97.3,76.3z" />
            </g>
            <g id="original-price">
              <path class="browse-st15" d="M84.2,69.3l0.6-0.1c0.1,0.5,0.5,0.7,0.9,0.7c0.8,0,1.1-0.8,0.3-1c-0.9-0.3-1.8-0.4-1.8-1.3
           c0-1.5,2.5-1.6,2.8,0c-1,0.2-0.5,0.2-0.8-0.2c-0.5-0.7-1.8-0.1-1.2,0.5c0.5,0.5,2.1,0.2,2.1,1.5C87.2,70.8,84.5,71,84.2,69.3z
           M85.4,66.6V66h0.7v0.6H85.4z M85.4,71v-0.6h0.7V71H85.4z" />
              <path class="browse-st15"
                d="M89.3,70.4v-0.6h-1.7c0-0.8-0.2-0.2,1.3-3.3h0.7l-1.3,2.7h1v-1H90v1h0.4v0.6H90v0.6H89.3z" />
              <path class="browse-st15" d="M91.1,70.4l1.4-3.3h-1.7v-0.6h2.4c0,0.8,0.2,0.1-1.3,3.9H91.1z" />
              <path class="browse-st15" d="M93.9,69.8c-0.2-0.4-0.2-0.7-0.2-2c0-1.9,2.8-1.9,2.8,0c0,1.3,0.1,1.6-0.2,2C95.8,70.7,94.4,70.7,93.9,69.8
           z M95.8,69.5c0.1-0.2,0.1-0.3,0.1-1.7c0-1-1.5-1-1.5,0c0,1.5,0,1.5,0.1,1.7C94.8,70,95.5,70,95.8,69.5z" />
            </g>
            <rect id="discount-line" x="83.7" y="68.1" class="browse-st13" width="13.8" height="0.7" />
          </g>
          <g id="offer-2">
            <g>
              <path class="browse-st11" d="M45.8,142.2c-0.8,0-1.5-0.7-1.5-1.5V105c0-0.8,0.7-1.5,1.5-1.5H100c0.8,0,1.5,0.7,1.5,1.5v35.6
           c0,0.8-0.7,1.5-1.5,1.5H45.8z" />
              <path class="browse-st16" d="M100,103.9c0.6,0,1.1,0.5,1.1,1.1v35.6c0,0.6-0.5,1.1-1.1,1.1H45.8c-0.6,0-1.1-0.5-1.1-1.1V105
           c0-0.6,0.5-1.1,1.1-1.1H100 M100,103.1H45.8c-1.1,0-1.9,0.9-1.9,1.9v35.6c0,1.1,0.9,1.9,1.9,1.9H100c1.1,0,1.9-0.9,1.9-1.9V105
           C101.9,104,101.1,103.1,100,103.1L100,103.1z" />
            </g>
            <g>
              <path class="browse-st8" d="M96.6,132.2H49.1c-0.4,0-0.7-0.3-0.7-0.7v0c0-0.4,0.3-0.7,0.7-0.7h47.5c0.4,0,0.7,0.3,0.7,0.7v0
           C97.3,131.8,97,132.2,96.6,132.2z" />
              <path class="browse-st8" d="M72.9,134.4H49.1c-0.4,0-0.7-0.3-0.7-0.7v0c0-0.4,0.3-0.7,0.7-0.7h23.8c0.4,0,0.7,0.3,0.7,0.7v0
           C73.5,134.1,73.2,134.4,72.9,134.4z" />
            </g>
            <g>
              <g>
                <rect x="75.5" y="124.5" class="browse-st13" width="2.2" height="2.2" />
                <polyline class="browse-st14" points="77.9,124.5 76.6,125.9 76.2,125.3 				" />
              </g>
              <g>
                <path class="browse-st5" d="M70.4,126.2v-1.4h0.9v0.2h-0.7v0.4h0.6v0.2h-0.6v0.5h0.7v0.2H70.4z" />
                <path class="browse-st5"
                  d="M71.3,126.2l0.5-0.7l-0.5-0.7h0.2l0.4,0.5l0.4-0.5h0.2l-0.5,0.7l0.5,0.7h-0.2l-0.4-0.5l-0.4,0.5H71.3z" />
                <path class="browse-st5" d="M72.6,126.2v-1.4h0.5c0,0,0,0,0,0c0,0,0,0,0.1,0c0.1,0,0.1,0,0.2,0.1s0.1,0.1,0.1,0.1c0,0.1,0,0.1,0,0.2
             c0,0.1,0,0.1,0,0.2c0,0.1-0.1,0.1-0.1,0.1c0,0-0.1,0.1-0.2,0.1c0,0,0,0-0.1,0c0,0,0,0,0,0h-0.4v0.5H72.6z M72.8,125.5h0.4
             c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1,0,0.1-0.1c0,0,0-0.1,0.1-0.1c0,0,0-0.1,0-0.1s0-0.1,0-0.1c0,0,0-0.1-0.1-0.1
             c0,0-0.1,0-0.1-0.1c0,0,0,0,0,0c0,0,0,0,0,0h-0.4V125.5z" />
                <path class="browse-st5" d="M74.4,126.2V125l-0.3,0.2V125l0.3-0.2h0.2v1.4H74.4z" />
              </g>
            </g>
            <g>
              <g>
                <rect x="85.1" y="124.5" class="browse-st13" width="2.2" height="2.2" />
                <g>
                  <line class="browse-st17" x1="86.8" y1="125" x2="85.7" y2="126.2" />
                  <line class="browse-st17" x1="85.7" y1="125" x2="86.8" y2="126.2" />
                </g>
              </g>
              <g>
                <path class="browse-st5" d="M79.7,126.2v-1.4h0.9v0.2h-0.7v0.4h0.6v0.2h-0.6v0.5h0.7v0.2H79.7z" />
                <path class="browse-st5"
                  d="M80.6,126.2l0.5-0.7l-0.5-0.7h0.2l0.4,0.5l0.4-0.5h0.2l-0.5,0.7l0.5,0.7h-0.2l-0.4-0.5l-0.4,0.5H80.6z" />
                <path class="browse-st5" d="M81.9,126.2v-1.4h0.5c0,0,0,0,0,0c0,0,0,0,0.1,0c0.1,0,0.1,0,0.2,0.1c0,0,0.1,0.1,0.1,0.1
             c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.1-0.1,0.1-0.1,0.1c0,0-0.1,0.1-0.2,0.1c0,0,0,0-0.1,0c0,0,0,0,0,0h-0.4v0.5H81.9z
             M82.1,125.5h0.4c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1,0,0.1-0.1c0,0,0-0.1,0.1-0.1c0,0,0-0.1,0-0.1s0-0.1,0-0.1c0,0,0-0.1-0.1-0.1
             c0,0-0.1,0-0.1-0.1c0,0,0,0,0,0c0,0,0,0,0,0h-0.4V125.5z" />
                <path class="browse-st5" d="M83.4,126.2l0-0.2l0.6-0.5c0.1,0,0.1-0.1,0.1-0.1c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.1c0,0-0.1-0.1-0.1-0.1
             s-0.1,0-0.1,0c-0.1,0-0.1,0-0.1,0c0,0-0.1,0.1-0.1,0.1c0,0,0,0.1,0,0.1h-0.2c0-0.1,0-0.2,0.1-0.2c0-0.1,0.1-0.1,0.2-0.2
             c0.1,0,0.1-0.1,0.2-0.1c0.1,0,0.2,0,0.2,0.1c0.1,0,0.1,0.1,0.2,0.2c0,0.1,0.1,0.1,0.1,0.2c0,0.1,0,0.1,0,0.2c0,0,0,0.1-0.1,0.1
             c0,0-0.1,0.1-0.1,0.1l-0.5,0.4l0-0.1h0.7v0.2H83.4z" />
              </g>
            </g>
            <g>
              <g>
                <rect x="94.8" y="124.5" class="browse-st13" width="2.2" height="2.2" />
                <polyline class="browse-st14" points="97.2,124.5 95.9,125.9 95.5,125.3 				" />
              </g>
              <g>
                <path class="browse-st5" d="M89.3,126.2v-1.4h0.9v0.2h-0.7v0.4h0.6v0.2h-0.6v0.5h0.7v0.2H89.3z" />
                <path class="browse-st5"
                  d="M90.3,126.2l0.5-0.7l-0.5-0.7h0.2l0.4,0.5l0.4-0.5h0.2l-0.5,0.7l0.5,0.7h-0.2l-0.4-0.5l-0.4,0.5H90.3z" />
                <path class="browse-st5" d="M91.6,126.2v-1.4h0.5c0,0,0,0,0,0c0,0,0,0,0.1,0c0.1,0,0.1,0,0.2,0.1c0,0,0.1,0.1,0.1,0.1
             c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.1-0.1,0.1-0.1,0.1c0,0-0.1,0.1-0.2,0.1c0,0,0,0-0.1,0c0,0,0,0,0,0h-0.4v0.5H91.6z
             M91.8,125.5h0.4c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1,0,0.1-0.1c0,0,0-0.1,0.1-0.1c0,0,0-0.1,0-0.1s0-0.1,0-0.1c0,0,0-0.1-0.1-0.1
             c0,0-0.1,0-0.1-0.1c0,0,0,0,0,0c0,0,0,0,0,0h-0.4V125.5z" />
                <path class="browse-st5"
                  d="M93.5,126.2c-0.1,0-0.1,0-0.2,0s-0.1-0.1-0.1-0.1c0,0-0.1-0.1-0.1-0.2l0.2,0c0,0.1,0.1,0.1,0.1,0.1
             c0,0,0.1,0,0.2,0c0.1,0,0.1,0,0.1,0c0,0,0.1-0.1,0.1-0.1c0,0,0-0.1,0-0.1c0-0.1,0-0.2-0.1-0.2c-0.1-0.1-0.1-0.1-0.2-0.1
             c0,0,0,0-0.1,0c0,0,0,0-0.1,0l-0.1-0.1l0.5-0.5l0,0.1h-0.7v-0.2h0.8v0.2l-0.4,0.4l0-0.1c0.1,0,0.2,0,0.2,0
             c0.1,0,0.1,0.1,0.2,0.2c0,0.1,0.1,0.1,0.1,0.2c0,0.1,0,0.2-0.1,0.2c0,0.1-0.1,0.1-0.2,0.2C93.7,126.2,93.6,126.2,93.5,126.2z" />
              </g>
            </g>
            <g>
              <g>
                <g>
                  <path class="browse-st18" d="M51.6,110.4c2.8,4.7,3.8,8.2,4.3,11.7c0,0.3,0.8,0.2,0.7-0.1c-1-4.6-2.2-7.9-4.8-11.8
               C51.6,110.1,51.5,110.3,51.6,110.4z" />
                </g>
                <g>
                  <path class="browse-st18" d="M63.7,110.1c-0.1,3.6-1.2,12.5-1.3,16.7c0,0.3,0.8,0.4,0.8,0.1c0.1-4.2,0.6-12.6,0.8-16.8
               C64,109.9,63.7,109.9,63.7,110.1z" />
                </g>
                <g>
                  <path class="browse-st18" d="M53.5,110.5c-0.4-0.2-1.2-0.3-1.7-0.2c0.2-0.1,0.5-0.2,0.8-0.3l0.1-0.2l0.1,0.2c0.1,0,0.3-0.1,0.4-0.1
               l0.1-0.2l0.1,0.2c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0l0-0.2l0.1,0.2c0.5,0,0.7,0.1,1.1,0.4c-0.2-0.5-0.7-1.1-1.6-1.1
               c-0.6,0-1.2,0.7-1.5,1.1c0.2-0.4,0.6-1.2,0.9-1.4c0.6-0.4,1.3-0.5,1.9-0.5c-0.5-0.3-1.4-0.7-2.5-0.1c-0.5,0.2-0.5,1.2-0.5,1.8
               c-0.1-0.4-0.2-1-0.1-1.3c0.1-0.7,0.3-0.9,0.7-1.1c-0.2,0-1.1-0.4-1.5,0.8c-0.2,0.6,0.3,1.3,0.7,1.7c-0.4-0.4-1.1-0.9-1.7-0.8
               c-1.3,0.2-1.3,1-1.3,1.3c0.4-0.3,0.8-0.4,1.5-0.5c0.3,0,0.8,0.1,1.2,0.2c-0.7,0-1.9,0.2-2.5,0.6c-0.7,0.6-0.9,2.1-0.7,2.8
               c0.1-0.4,0.4-0.8,0.6-1.2l0-0.4l0.1,0.2c0.1-0.1,0.2-0.2,0.3-0.3l0-0.5l0.2,0.4c0.1-0.1,0.2-0.2,0.3-0.3l-0.1-0.5l0.3,0.4
               c0.3-0.2,0.7-0.4,1.2-0.6c-0.5,0.3-1,0.8-1.2,1.3c-0.3,0.8,0.4,1.9,0.5,2.2c0.1-0.3,0.1-0.8,0.2-1.2l-0.3-0.2l0.3,0
               c0-0.1,0.1-0.2,0.1-0.4l-0.3-0.3l0.4,0.1c0-0.1,0.1-0.2,0.1-0.3c0,0,0-0.1,0.1-0.1l-0.2-0.2l0.2,0c0.3-0.5,0.9-1.3,0.9-1.3
               c0.2,0.1,1.3,0.6,1.6,0.9c0.5,0.4,0.8,0.3,1.1,0.5C54.3,111.3,54.3,110.9,53.5,110.5z" />
                </g>
                <g>
                  <g>
                    <path class="browse-st18" d="M66.6,109.2c-0.7-0.1-1.7,0.3-2.3,0.6c0.3-0.3,0.8-0.6,1-0.8c0.6-0.3,1.1-0.4,1.5-0.3
                 c-0.1-0.2-0.4-0.9-1.7-0.5c-0.6,0.2-1,1.1-1.1,1.6c0.1-0.5,0.2-1.5-0.2-1.9c-0.9-0.9-1.5-0.1-1.7,0c0.5,0,0.7,0.1,1.2,0.6
                 c0.2,0.2,0.4,0.8,0.5,1.2c-0.3-0.5-0.8-1.3-1.3-1.3c-1.2,0-1.8,0.8-2.1,1.3c0.3-0.2,0.7-0.3,1.1-0.4l0.3-0.3l-0.1,0.3
                 c0.2,0,0.3,0,0.5,0l0.3-0.3l0,0.3c0.1,0,0.2,0.1,0.4,0.1l0.2-0.2l0,0.2c0.3,0.2,0.7,0.4,0.9,0.5c-0.5-0.2-1.3-0.4-1.9-0.2
                 c-0.8,0.4-0.9,1.1-0.9,1.7c0.2-0.5,0.5-0.6,1-1c0.3-0.2,1.3-0.3,1.7-0.3c-0.4,0.2-1.1,0.6-1.4,1c-0.5,0.7-0.3,1-0.2,1.5
                 c0.2-0.3,0.5-0.4,0.7-1c0.2-0.4,0.8-1.3,1-1.5c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0.2,0.1,0.6,0.4,0.9,0.6l0.2-0.1l0,0.2
                 c0.1,0.1,0.1,0.1,0.2,0.1c0,0,0.1,0.1,0.1,0.1l0.2-0.3l0,0.4c0.1,0.1,0.2,0.1,0.2,0.2l0.2-0.2l0,0.3c0.1,0.1,0.2,0.1,0.3,0.2
                 l0.1-0.1l0,0.2c0.1,0.1,0.2,0.1,0.3,0.2c0.1-0.3,0.2-0.8-0.5-1.4c-0.4-0.4-1.1-0.6-1.6-0.6c0.3,0,0.6,0,1,0l0.1-0.2l0.1,0.3
                 c0.1,0,0.3,0,0.4,0l0.1-0.3l0.2,0.4c0,0,0.1,0,0.1,0c0.1,0,0.2,0,0.3,0l0.1-0.3l0.1,0.3c0.1,0,0.2,0,0.3,0.1l0-0.2l0.1,0.2
                 c0.2,0.1,0.3,0.2,0.6,0.3C67.7,110.1,67.5,109.4,66.6,109.2z M63.9,110.1L63.9,110.1C63.9,110.1,63.9,110.1,63.9,110.1
                 L63.9,110.1z" />
                  </g>
                </g>
              </g>
              <path class="browse-st18" d="M60.2,128.2h7h0.5v-7.4h0.6v-0.5h-0.7l-1.3-0.5h-0.7v-3.3h0.3V116h0.3v-0.6h-0.6l-5.2-1.1H60V114h-3.9v0.2
           h-0.3l-4.9,1.1h-0.6v0.6h0.4v0.5H51v3.3h-0.9l-1.3,0.5h-0.7v0.5h0.7v7.4h0.5H56h0.5v0h3.1v0H60.2 M49.4,120.8h0.9v5.6l-0.9,0.4h0
           V120.8z M67.1,126.9L67.1,126.9l-1.2-0.4v-5.6h1.2V126.9z" />
            </g>
            <rect x="85.5" y="134.5" class="browse-st13" width="11.9" height="4.5" />
            <g>
              <g>
                <path class="browse-st5" d="M88.3,137.9l-0.7-2.3h0.4l0.6,2l0.6-2h0.4l-0.7,2.3H88.3z" />
                <path class="browse-st5" d="M89.9,137.9v-2.3h0.4v2.3H89.9z" />
                <path class="browse-st5" d="M90.7,137.9v-2.3h1.5v0.4h-1.1v0.6h0.9v0.4h-0.9v0.7h1.1v0.4H90.7z" />
                <path class="browse-st5" d="M93.1,137.9l-0.7-2.3h0.4l0.5,1.7l0.5-1.7l0.4,0l0.5,1.7l0.5-1.7h0.4l-0.7,2.3h-0.4l-0.5-1.7l-0.5,1.7H93.1
             z" />
              </g>
            </g>
            <g id="discount-price">
              <path class="browse-st5"
                d="M80.2,122c-0.5,0-0.9-0.1-1.2-0.3s-0.7-0.4-0.9-0.7c-0.2-0.3-0.4-0.7-0.4-1.1l1.1-0.2
           c0.1,0.4,0.3,0.7,0.5,0.9c0.3,0.2,0.6,0.3,1,0.3c0.4,0,0.7-0.1,0.9-0.3c0.2-0.2,0.4-0.4,0.4-0.7c0-0.2-0.1-0.3-0.2-0.5
           c-0.1-0.1-0.3-0.2-0.6-0.3l-1.6-0.5c-0.9-0.3-1.4-0.8-1.4-1.7c0-0.4,0.1-0.7,0.3-1c0.2-0.3,0.4-0.5,0.8-0.7
           c0.3-0.2,0.7-0.2,1.2-0.2c0.4,0,0.8,0.1,1.1,0.2c0.3,0.2,0.6,0.4,0.8,0.7c0.2,0.3,0.4,0.6,0.5,1l-1.1,0.2c0-0.2-0.1-0.4-0.2-0.6
           c-0.1-0.2-0.3-0.3-0.5-0.4c-0.2-0.1-0.4-0.1-0.6-0.1c-0.2,0-0.4,0-0.6,0.1c-0.2,0.1-0.3,0.2-0.4,0.3c-0.1,0.1-0.2,0.3-0.2,0.4
           c0,0.2,0.1,0.3,0.2,0.5c0.1,0.1,0.4,0.2,0.7,0.3l1.2,0.3c0.6,0.2,1,0.4,1.2,0.7c0.2,0.3,0.4,0.6,0.4,1.1c0,0.4-0.1,0.8-0.3,1.1
           c-0.2,0.3-0.5,0.5-0.9,0.7C81.1,121.9,80.7,122,80.2,122z M79.6,115.5v-1.1h1.1v1.1H79.6z M79.6,122.8v-1.1h1.1v1.1H79.6z" />
              <path class="browse-st5" d="M85.3,122c-0.3,0-0.6-0.1-0.9-0.2c-0.3-0.1-0.5-0.3-0.8-0.5c-0.2-0.2-0.4-0.5-0.5-0.8l1.1-0.3
           c0.1,0.3,0.2,0.5,0.4,0.6c0.2,0.1,0.4,0.2,0.7,0.2c0.2,0,0.4,0,0.6-0.1c0.2-0.1,0.3-0.2,0.4-0.4c0.1-0.2,0.1-0.4,0.1-0.6
           c0-0.3-0.1-0.6-0.3-0.8c-0.2-0.2-0.5-0.3-0.8-0.3c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2,0.1-0.3,0.1l-0.5-0.9l2.2-1.9l0.1,0.3h-3.1v-1h4
           v1l-1.8,1.7l0-0.3c0.4,0,0.7,0.1,1,0.3c0.3,0.2,0.5,0.4,0.6,0.7c0.1,0.3,0.2,0.6,0.2,1c0,0.4-0.1,0.8-0.3,1.1
           c-0.2,0.3-0.5,0.6-0.8,0.8C86.1,121.9,85.7,122,85.3,122z" />
              <path class="browse-st5" d="M88.8,121.9l2.2-5.5h-2.8v-1h4v1l-2.2,5.5H88.8z" />
              <path class="browse-st5"
                d="M94.7,115.2c0.4,0,0.8,0.1,1.1,0.3c0.3,0.2,0.6,0.5,0.8,0.8c0.2,0.4,0.3,0.8,0.3,1.2v2
           c0,0.5-0.1,0.9-0.3,1.3c-0.2,0.4-0.5,0.6-0.8,0.8c-0.4,0.2-0.8,0.3-1.2,0.3c-0.3,0-0.6-0.1-0.9-0.2c-0.3-0.1-0.6-0.3-0.8-0.5
           l0.8-0.8c0.1,0.1,0.3,0.2,0.4,0.3c0.2,0.1,0.3,0.1,0.5,0.1c0.3,0,0.5-0.1,0.7-0.2c0.2-0.1,0.3-0.3,0.4-0.5
           c0.1-0.2,0.2-0.4,0.2-0.6v-1.1l0.2,0.2c-0.2,0.2-0.4,0.4-0.7,0.5c-0.3,0.1-0.5,0.2-0.8,0.2c-0.4,0-0.8-0.1-1.1-0.3
           c-0.3-0.2-0.6-0.4-0.7-0.8c-0.2-0.3-0.3-0.7-0.3-1.1c0-0.4,0.1-0.8,0.3-1.1c0.2-0.3,0.5-0.6,0.8-0.8
           C93.9,115.3,94.3,115.2,94.7,115.2z M94.7,116.3c-0.2,0-0.4,0.1-0.6,0.2c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.2-0.2,0.4-0.2,0.6
           c0,0.2,0.1,0.4,0.2,0.6c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.4,0.2,0.6,0.2s0.4-0.1,0.6-0.2c0.2-0.1,0.3-0.2,0.4-0.4
           c0.1-0.2,0.2-0.4,0.2-0.6c0-0.2-0.1-0.4-0.2-0.6c-0.1-0.2-0.2-0.3-0.4-0.4C95.1,116.3,94.9,116.3,94.7,116.3z" />
            </g>
            <g id="original-price">
              <path class="browse-st15"
                d="M85.2,112.8c-0.3,0-0.5-0.1-0.8-0.2c-0.2-0.1-0.4-0.3-0.5-0.4c-0.1-0.2-0.2-0.4-0.3-0.7l0.7-0.1
           c0.1,0.2,0.2,0.4,0.3,0.5c0.2,0.1,0.4,0.2,0.6,0.2c0.2,0,0.4-0.1,0.6-0.2c0.1-0.1,0.2-0.2,0.2-0.4c0-0.1,0-0.2-0.1-0.3
           c-0.1-0.1-0.2-0.1-0.3-0.2l-1-0.3c-0.6-0.2-0.8-0.5-0.8-1c0-0.2,0.1-0.4,0.2-0.6c0.1-0.2,0.3-0.3,0.5-0.4
           c0.2-0.1,0.5-0.1,0.7-0.1c0.3,0,0.5,0,0.7,0.1c0.2,0.1,0.4,0.2,0.5,0.4c0.1,0.2,0.2,0.4,0.3,0.6l-0.7,0.1c0-0.1-0.1-0.2-0.2-0.3
           c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1-0.1-0.2-0.1-0.4-0.1c-0.1,0-0.3,0-0.4,0.1c-0.1,0-0.2,0.1-0.3,0.2c-0.1,0.1-0.1,0.2-0.1,0.3
           c0,0.1,0,0.2,0.1,0.3c0.1,0.1,0.2,0.1,0.4,0.2l0.7,0.2c0.3,0.1,0.6,0.2,0.7,0.4c0.2,0.2,0.2,0.4,0.2,0.7c0,0.2-0.1,0.5-0.2,0.7
           c-0.1,0.2-0.3,0.3-0.5,0.4C85.8,112.7,85.5,112.8,85.2,112.8z M84.9,108.8v-0.7h0.7v0.7H84.9z M84.9,113.2v-0.7h0.7v0.7H84.9z" />
              <path class="browse-st15"
                d="M89,112.7V112h-1.8v-0.6l1.3-2.7h0.8l-1.3,2.7h1v-1h0.7v1H90v0.6h-0.4v0.7H89z" />
              <path class="browse-st15" d="M91.8,108.6c0.3,0,0.5,0.1,0.7,0.2c0.2,0.1,0.4,0.3,0.5,0.5c0.1,0.2,0.2,0.5,0.2,0.8v1.2
           c0,0.3-0.1,0.6-0.2,0.8c-0.1,0.2-0.3,0.4-0.5,0.5s-0.5,0.2-0.8,0.2c-0.2,0-0.4,0-0.6-0.1c-0.2-0.1-0.3-0.2-0.5-0.3l0.5-0.5
           c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0,0.2,0.1,0.3,0.1c0.2,0,0.3,0,0.4-0.1c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.1-0.2,0.1-0.4v-0.7
           l0.1,0.1c-0.1,0.1-0.3,0.2-0.4,0.3c-0.2,0.1-0.3,0.1-0.5,0.1c-0.3,0-0.5-0.1-0.7-0.2s-0.3-0.3-0.5-0.5c-0.1-0.2-0.2-0.4-0.2-0.7
           c0-0.3,0.1-0.5,0.2-0.7c0.1-0.2,0.3-0.4,0.5-0.5C91.4,108.7,91.6,108.6,91.8,108.6z M91.8,109.2c-0.1,0-0.2,0-0.4,0.1
           c-0.1,0.1-0.2,0.1-0.3,0.3c-0.1,0.1-0.1,0.2-0.1,0.4c0,0.1,0,0.2,0.1,0.4c0.1,0.1,0.1,0.2,0.3,0.3c0.1,0.1,0.2,0.1,0.4,0.1
           c0.1,0,0.2,0,0.4-0.1c0.1-0.1,0.2-0.1,0.3-0.3c0.1-0.1,0.1-0.2,0.1-0.4c0-0.1,0-0.2-0.1-0.3c-0.1-0.1-0.1-0.2-0.3-0.3
           C92.1,109.3,92,109.2,91.8,109.2z" />
              <path class="browse-st15" d="M95.3,108.6c0.3,0,0.5,0.1,0.7,0.2c0.2,0.1,0.4,0.3,0.5,0.5c0.1,0.2,0.2,0.5,0.2,0.8v1.2
           c0,0.3-0.1,0.6-0.2,0.8c-0.1,0.2-0.3,0.4-0.5,0.5c-0.2,0.1-0.5,0.2-0.8,0.2c-0.2,0-0.4,0-0.6-0.1c-0.2-0.1-0.3-0.2-0.5-0.3
           l0.5-0.5c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0,0.2,0.1,0.3,0.1c0.2,0,0.3,0,0.4-0.1c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.1-0.2,0.1-0.4
           v-0.7l0.1,0.1c-0.1,0.1-0.3,0.2-0.4,0.3s-0.3,0.1-0.5,0.1c-0.3,0-0.5-0.1-0.7-0.2c-0.2-0.1-0.3-0.3-0.5-0.5
           c-0.1-0.2-0.2-0.4-0.2-0.7c0-0.3,0.1-0.5,0.2-0.7c0.1-0.2,0.3-0.4,0.5-0.5C94.8,108.7,95,108.6,95.3,108.6z M95.3,109.2
           c-0.1,0-0.2,0-0.4,0.1c-0.1,0.1-0.2,0.1-0.3,0.3c-0.1,0.1-0.1,0.2-0.1,0.4c0,0.1,0,0.2,0.1,0.4c0.1,0.1,0.1,0.2,0.3,0.3
           c0.1,0.1,0.2,0.1,0.4,0.1c0.1,0,0.2,0,0.4-0.1c0.1-0.1,0.2-0.1,0.3-0.3c0.1-0.1,0.1-0.2,0.1-0.4c0-0.1,0-0.2-0.1-0.3
           c-0.1-0.1-0.1-0.2-0.3-0.3C95.5,109.3,95.4,109.2,95.3,109.2z" />
            </g>
            <rect id="discount-line" x="83.4" y="110.1" class="browse-st13" width="13.8" height="0.7" />
          </g>
          <g id="offer-3">
            <g>
              <path class="browse-st11" d="M46.1,184.2c-0.8,0-1.5-0.7-1.5-1.5V147c0-0.8,0.7-1.5,1.5-1.5h54.2c0.8,0,1.5,0.7,1.5,1.5v35.6
           c0,0.8-0.7,1.5-1.5,1.5H46.1z" />
              <path class="browse-st19" d="M100.3,145.9c0.6,0,1.1,0.5,1.1,1.1v35.6c0,0.6-0.5,1.1-1.1,1.1H46.1c-0.6,0-1.1-0.5-1.1-1.1V147
           c0-0.6,0.5-1.1,1.1-1.1H100.3 M100.3,145.1H46.1c-1.1,0-1.9,0.9-1.9,1.9v35.6c0,1.1,0.9,1.9,1.9,1.9h54.2c1.1,0,1.9-0.9,1.9-1.9
           V147C102.2,146,101.3,145.1,100.3,145.1L100.3,145.1z" />
            </g>
            <g>
              <path class="browse-st8" d="M96.9,174.2H49.3c-0.4,0-0.7-0.3-0.7-0.7v0c0-0.4,0.3-0.7,0.7-0.7h47.5c0.4,0,0.7,0.3,0.7,0.7v0
           C97.5,173.8,97.2,174.2,96.9,174.2z" />
              <path class="browse-st8" d="M73.1,176.4H49.3c-0.4,0-0.7-0.3-0.7-0.7v0c0-0.4,0.3-0.7,0.7-0.7h23.8c0.4,0,0.7,0.3,0.7,0.7v0
           C73.8,176.1,73.5,176.4,73.1,176.4z" />
            </g>
            <g>
              <g>
                <rect x="75.7" y="166.5" class="browse-st13" width="2.2" height="2.2" />
                <polyline class="browse-st14" points="78.1,166.5 76.9,167.9 76.4,167.3 				" />
              </g>
              <g>
                <path class="browse-st5" d="M70.6,168.2v-1.4h0.9v0.2h-0.7v0.4h0.6v0.2h-0.6v0.5h0.7v0.2H70.6z" />
                <path class="browse-st5"
                  d="M71.6,168.2l0.5-0.7l-0.5-0.7h0.2l0.4,0.5l0.4-0.5h0.2l-0.5,0.7l0.5,0.7h-0.2l-0.4-0.5l-0.4,0.5H71.6z" />
                <path class="browse-st5" d="M72.9,168.2v-1.4h0.5c0,0,0,0,0,0c0,0,0,0,0.1,0c0.1,0,0.1,0,0.2,0.1s0.1,0.1,0.1,0.1c0,0.1,0,0.1,0,0.2
             c0,0.1,0,0.1,0,0.2c0,0.1-0.1,0.1-0.1,0.1c0,0-0.1,0.1-0.2,0.1c0,0,0,0-0.1,0c0,0,0,0,0,0H73v0.5H72.9z M73,167.5h0.4
             c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1,0,0.1-0.1c0,0,0-0.1,0.1-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1-0.1-0.1
             c0,0-0.1,0-0.1-0.1c0,0,0,0,0,0c0,0,0,0,0,0H73V167.5z" />
                <path class="browse-st5" d="M74.6,168.2V167l-0.3,0.2V167l0.3-0.2h0.2v1.4H74.6z" />
              </g>
            </g>
            <g>
              <g>
                <rect x="85.4" y="166.5" class="browse-st13" width="2.2" height="2.2" />
                <polyline class="browse-st14" points="87.8,166.5 86.6,167.9 86.1,167.3 				" />
              </g>
              <g>
                <path class="browse-st5" d="M79.9,168.2v-1.4h0.9v0.2h-0.7v0.4h0.6v0.2h-0.6v0.5h0.7v0.2H79.9z" />
                <path class="browse-st5"
                  d="M80.9,168.2l0.5-0.7l-0.5-0.7h0.2l0.4,0.5l0.4-0.5H82l-0.5,0.7l0.5,0.7h-0.2l-0.4-0.5l-0.4,0.5H80.9z" />
                <path class="browse-st5" d="M82.2,168.2v-1.4h0.5c0,0,0,0,0,0c0,0,0,0,0.1,0c0.1,0,0.1,0,0.2,0.1c0,0,0.1,0.1,0.1,0.1
             c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.1-0.1,0.1-0.1,0.1c0,0-0.1,0.1-0.2,0.1c0,0,0,0-0.1,0c0,0,0,0,0,0h-0.4v0.5H82.2z
             M82.3,167.5h0.4c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1,0,0.1-0.1c0,0,0-0.1,0.1-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1
             c0,0,0-0.1-0.1-0.1c0,0-0.1,0-0.1-0.1c0,0,0,0,0,0c0,0,0,0,0,0h-0.4V167.5z" />
                <path class="browse-st5" d="M83.7,168.2l0-0.2l0.6-0.5c0.1,0,0.1-0.1,0.1-0.1c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.1c0,0-0.1-0.1-0.1-0.1
             s-0.1,0-0.1,0c-0.1,0-0.1,0-0.1,0c0,0-0.1,0.1-0.1,0.1c0,0,0,0.1,0,0.1h-0.2c0-0.1,0-0.2,0.1-0.2c0-0.1,0.1-0.1,0.2-0.2
             c0.1,0,0.1-0.1,0.2-0.1c0.1,0,0.2,0,0.2,0.1c0.1,0,0.1,0.1,0.2,0.2c0,0.1,0.1,0.1,0.1,0.2c0,0.1,0,0.1,0,0.2c0,0,0,0.1-0.1,0.1
             s-0.1,0.1-0.1,0.1l-0.5,0.4l0-0.1h0.7v0.2H83.7z" />
              </g>
            </g>
            <g>
              <g>
                <rect x="95" y="166.5" class="browse-st13" width="2.2" height="2.2" />
                <g>
                  <line class="browse-st17" x1="96.7" y1="167" x2="95.6" y2="168.2" />
                  <line class="browse-st17" x1="95.6" y1="167" x2="96.7" y2="168.2" />
                </g>
              </g>
              <g>
                <path class="browse-st5" d="M89.6,168.2v-1.4h0.9v0.2h-0.7v0.4h0.6v0.2h-0.6v0.5h0.7v0.2H89.6z" />
                <path class="browse-st5"
                  d="M90.6,168.2l0.5-0.7l-0.5-0.7h0.2l0.4,0.5l0.4-0.5h0.2l-0.5,0.7l0.5,0.7h-0.2l-0.4-0.5l-0.4,0.5H90.6z" />
                <path class="browse-st5" d="M91.9,168.2v-1.4h0.5c0,0,0,0,0,0c0,0,0,0,0.1,0c0.1,0,0.1,0,0.2,0.1c0,0,0.1,0.1,0.1,0.1
             c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.1-0.1,0.1-0.1,0.1c0,0-0.1,0.1-0.2,0.1c0,0,0,0-0.1,0c0,0,0,0,0,0H92v0.5H91.9z
             M92,167.5h0.4c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1,0,0.1-0.1c0,0,0-0.1,0.1-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1
             c0,0,0-0.1-0.1-0.1s-0.1,0-0.1-0.1c0,0,0,0,0,0c0,0,0,0,0,0H92V167.5z" />
                <path class="browse-st5" d="M93.8,168.2c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1-0.1-0.1-0.1c0,0-0.1-0.1-0.1-0.2l0.2,0c0,0.1,0.1,0.1,0.1,0.1
             c0,0,0.1,0,0.2,0c0.1,0,0.1,0,0.1,0c0,0,0.1-0.1,0.1-0.1c0,0,0-0.1,0-0.1c0-0.1,0-0.2-0.1-0.2c-0.1-0.1-0.1-0.1-0.2-0.1
             c0,0,0,0-0.1,0c0,0,0,0-0.1,0l-0.1-0.1L94,167l0,0.1h-0.7v-0.2h0.8v0.2l-0.4,0.4l0-0.1c0.1,0,0.2,0,0.2,0c0.1,0,0.1,0.1,0.2,0.2
             c0,0.1,0.1,0.1,0.1,0.2c0,0.1,0,0.2-0.1,0.2c0,0.1-0.1,0.1-0.2,0.2C93.9,168.2,93.8,168.2,93.8,168.2z" />
              </g>
            </g>
            <g>
              <g>
                <g>
                  <path class="browse-st19" d="M51.8,152.4c2.8,4.7,3.8,8.2,4.3,11.7c0,0.3,0.8,0.2,0.7-0.1c-1-4.6-2.2-7.9-4.8-11.8
               C51.9,152.1,51.8,152.3,51.8,152.4z" />
                </g>
                <g>
                  <path class="browse-st19" d="M64,152.1c-0.1,3.6-1.2,12.5-1.3,16.7c0,0.3,0.8,0.4,0.8,0.1c0.1-4.2,0.6-12.6,0.8-16.8
               C64.3,151.9,64,151.9,64,152.1z" />
                </g>
                <g>
                  <path class="browse-st19" d="M53.8,152.5c-0.4-0.2-1.2-0.3-1.7-0.2c0.2-0.1,0.5-0.2,0.8-0.3l0.1-0.2l0.1,0.2c0.1,0,0.3-0.1,0.4-0.1
               l0.1-0.2l0.1,0.2c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0l0-0.2l0.1,0.2c0.5,0,0.7,0.1,1.1,0.4c-0.2-0.5-0.7-1.1-1.6-1.1
               c-0.6,0-1.2,0.7-1.5,1.1c0.2-0.4,0.6-1.2,0.9-1.4c0.6-0.4,1.3-0.5,1.9-0.5c-0.5-0.3-1.4-0.7-2.5-0.1c-0.5,0.2-0.5,1.2-0.5,1.8
               c-0.1-0.4-0.2-1-0.1-1.3c0.1-0.7,0.3-0.9,0.7-1.1c-0.2,0-1.1-0.4-1.5,0.8c-0.2,0.6,0.3,1.3,0.7,1.7c-0.4-0.4-1.1-0.9-1.7-0.8
               c-1.3,0.2-1.3,1-1.3,1.3c0.4-0.3,0.8-0.4,1.5-0.5c0.3,0,0.8,0.1,1.2,0.2c-0.7,0-1.9,0.2-2.5,0.6c-0.7,0.6-0.9,2.1-0.7,2.8
               c0.1-0.4,0.4-0.8,0.6-1.2l0-0.4l0.1,0.2c0.1-0.1,0.2-0.2,0.3-0.3l0-0.5l0.2,0.4c0.1-0.1,0.2-0.2,0.3-0.3l-0.1-0.5l0.3,0.4
               c0.3-0.2,0.7-0.4,1.2-0.6c-0.5,0.3-1,0.8-1.2,1.3c-0.3,0.8,0.4,1.9,0.5,2.2c0.1-0.3,0.1-0.8,0.2-1.2l-0.3-0.2l0.3,0
               c0-0.1,0.1-0.2,0.1-0.4l-0.3-0.3l0.4,0.1c0-0.1,0.1-0.2,0.1-0.3c0,0,0-0.1,0.1-0.1l-0.2-0.2l0.2,0c0.3-0.5,0.9-1.3,0.9-1.3
               c0.2,0.1,1.3,0.6,1.6,0.9c0.5,0.4,0.8,0.3,1.1,0.5C54.5,153.3,54.5,152.9,53.8,152.5z" />
                </g>
                <g>
                  <g>
                    <path class="browse-st19" d="M66.8,151.2c-0.7-0.1-1.7,0.3-2.3,0.6c0.3-0.3,0.8-0.6,1-0.8c0.6-0.3,1.1-0.4,1.5-0.3
                 c-0.1-0.2-0.4-0.9-1.7-0.5c-0.6,0.2-1,1.1-1.1,1.6c0.1-0.5,0.2-1.5-0.2-1.9c-0.9-0.9-1.5-0.1-1.7,0c0.5,0,0.7,0.1,1.2,0.6
                 c0.2,0.2,0.4,0.8,0.5,1.2c-0.3-0.5-0.8-1.3-1.3-1.3c-1.2,0-1.8,0.8-2.1,1.3c0.3-0.2,0.7-0.3,1.1-0.4l0.3-0.3l-0.1,0.3
                 c0.2,0,0.3,0,0.5,0l0.3-0.3l0,0.3c0.1,0,0.2,0.1,0.4,0.1l0.2-0.2l0,0.2c0.3,0.2,0.7,0.4,0.9,0.5c-0.5-0.2-1.3-0.4-1.9-0.2
                 c-0.8,0.4-0.9,1.1-0.9,1.7c0.2-0.5,0.5-0.6,1-1c0.3-0.2,1.3-0.3,1.7-0.3c-0.4,0.2-1.1,0.6-1.4,1c-0.5,0.7-0.3,1-0.2,1.5
                 c0.2-0.3,0.5-0.4,0.7-1c0.2-0.4,0.8-1.3,1-1.5c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0.2,0.1,0.6,0.4,0.9,0.6l0.2-0.1l0,0.2
                 c0.1,0.1,0.1,0.1,0.2,0.1c0,0,0.1,0.1,0.1,0.1l0.2-0.3l0,0.4c0.1,0.1,0.2,0.1,0.2,0.2l0.2-0.2l0,0.3c0.1,0.1,0.2,0.1,0.3,0.2
                 l0.1-0.1l0,0.2c0.1,0.1,0.2,0.1,0.3,0.2c0.1-0.3,0.2-0.8-0.5-1.4c-0.4-0.4-1.1-0.6-1.6-0.6c0.3,0,0.6,0,1,0l0.1-0.2l0.1,0.3
                 c0.1,0,0.3,0,0.4,0l0.1-0.3l0.2,0.4c0,0,0.1,0,0.1,0c0.1,0,0.2,0,0.3,0l0.1-0.3l0.1,0.3c0.1,0,0.2,0,0.3,0.1l0-0.2l0.1,0.2
                 c0.2,0.1,0.3,0.2,0.6,0.3C68,152.1,67.8,151.4,66.8,151.2z M64.1,152.1L64.1,152.1C64.1,152.1,64.1,152.1,64.1,152.1
                 L64.1,152.1z" />
                  </g>
                </g>
              </g>
              <path class="browse-st19" d="M60.4,170.2h7h0.5v-7.4h0.6v-0.5h-0.7l-1.3-0.5h-0.7v-3.3h0.3V158h0.3v-0.6h-0.6l-5.2-1.1h-0.3V156h-3.9
           v0.2H56l-4.9,1.1h-0.6v0.6h0.4v0.5h0.4v3.3h-0.9l-1.3,0.5h-0.7v0.5h0.7v7.4h0.5h6.7h0.5v0h3.1v0H60.4 M49.6,162.8h0.9v5.6
           l-0.9,0.4h0V162.8z M67.4,168.9L67.4,168.9l-1.2-0.4v-5.6h1.2V168.9z" />
            </g>
            <rect x="85.7" y="176.5" class="browse-st13" width="11.9" height="4.5" />
            <g>
              <g>
                <path class="browse-st5" d="M88.5,179.9l-0.7-2.3h0.4l0.6,2l0.6-2h0.4l-0.7,2.3H88.5z" />
                <path class="browse-st5" d="M90.1,179.9v-2.3h0.4v2.3H90.1z" />
                <path class="browse-st5" d="M91,179.9v-2.3h1.5v0.4h-1.1v0.6h0.9v0.4h-0.9v0.7h1.1v0.4H91z" />
                <path class="browse-st5" d="M93.4,179.9l-0.7-2.3h0.4l0.5,1.7l0.5-1.7l0.4,0l0.5,1.7l0.5-1.7h0.4l-0.7,2.3h-0.4l-0.5-1.7l-0.5,1.7H93.4
             z" />
              </g>
            </g>
            <g id="discount-price">
              <path class="browse-st5"
                d="M79.4,164c-0.5,0-0.9-0.1-1.2-0.3c-0.4-0.2-0.7-0.4-0.9-0.7c-0.2-0.3-0.4-0.7-0.4-1.1l1.1-0.2
           c0.1,0.4,0.3,0.7,0.5,0.9c0.3,0.2,0.6,0.3,1,0.3c0.4,0,0.7-0.1,0.9-0.3c0.2-0.2,0.4-0.4,0.4-0.7c0-0.2-0.1-0.3-0.2-0.5
           c-0.1-0.1-0.3-0.2-0.6-0.3l-1.6-0.5c-0.9-0.3-1.4-0.8-1.4-1.7c0-0.4,0.1-0.7,0.3-1c0.2-0.3,0.4-0.5,0.8-0.7
           c0.3-0.2,0.7-0.2,1.2-0.2c0.4,0,0.8,0.1,1.1,0.2c0.3,0.2,0.6,0.4,0.8,0.7c0.2,0.3,0.4,0.6,0.5,1l-1.1,0.2c0-0.2-0.1-0.4-0.2-0.6
           c-0.1-0.2-0.3-0.3-0.5-0.4c-0.2-0.1-0.4-0.1-0.6-0.1c-0.2,0-0.4,0-0.6,0.1c-0.2,0.1-0.3,0.2-0.4,0.3c-0.1,0.1-0.2,0.3-0.2,0.4
           c0,0.2,0.1,0.3,0.2,0.5c0.1,0.1,0.4,0.2,0.7,0.3l1.2,0.3c0.6,0.2,1,0.4,1.2,0.7c0.2,0.3,0.4,0.6,0.4,1.1c0,0.4-0.1,0.8-0.3,1.1
           c-0.2,0.3-0.5,0.5-0.9,0.7C80.3,163.9,79.9,164,79.4,164z M78.9,157.5v-1.1h1.1v1.1H78.9z M78.9,164.8v-1.1h1.1v1.1H78.9z" />
              <path class="browse-st5" d="M84.6,164c-0.3,0-0.6-0.1-0.9-0.2c-0.3-0.1-0.5-0.3-0.7-0.6c-0.2-0.2-0.4-0.5-0.4-0.8l1.1-0.3
           c0,0.2,0.1,0.3,0.2,0.5c0.1,0.1,0.2,0.2,0.4,0.3c0.2,0.1,0.3,0.1,0.5,0.1c0.2,0,0.4-0.1,0.6-0.2c0.2-0.1,0.3-0.2,0.4-0.4
           c0.1-0.2,0.2-0.4,0.2-0.6c0-0.2-0.1-0.4-0.2-0.6c-0.1-0.2-0.2-0.3-0.4-0.4c-0.2-0.1-0.4-0.2-0.6-0.2c-0.3,0-0.5,0-0.6,0.1
           c-0.2,0.1-0.3,0.2-0.4,0.3l-0.9-0.3l0.2-3.5h3.5v1h-3l0.4-0.4l-0.1,2.4l-0.2-0.2c0.2-0.2,0.4-0.3,0.6-0.3
           c0.2-0.1,0.4-0.1,0.6-0.1c0.4,0,0.8,0.1,1.1,0.3c0.3,0.2,0.6,0.4,0.7,0.8c0.2,0.3,0.3,0.7,0.3,1.1c0,0.4-0.1,0.8-0.3,1.1
           c-0.2,0.3-0.5,0.6-0.8,0.8C85.4,163.9,85,164,84.6,164z" />
              <path class="browse-st5"
                d="M90.5,163.9v-1.1h-2.9v-1l2.1-4.4h1.2l-2.1,4.4h1.6v-1.7h1.1v1.7h0.6v1h-0.6v1.1H90.5z" />
              <path class="browse-st5" d="M95,157.2c0.4,0,0.8,0.1,1.1,0.3c0.3,0.2,0.6,0.5,0.8,0.8c0.2,0.4,0.3,0.8,0.3,1.2v2c0,0.5-0.1,0.9-0.3,1.3
           c-0.2,0.4-0.5,0.6-0.8,0.8c-0.4,0.2-0.8,0.3-1.2,0.3c-0.3,0-0.6-0.1-0.9-0.2c-0.3-0.1-0.6-0.3-0.8-0.5l0.8-0.8
           c0.1,0.1,0.3,0.2,0.4,0.3c0.2,0.1,0.3,0.1,0.5,0.1c0.3,0,0.5-0.1,0.7-0.2c0.2-0.1,0.3-0.3,0.4-0.5c0.1-0.2,0.2-0.4,0.2-0.6v-1.1
           l0.2,0.2c-0.2,0.2-0.4,0.4-0.7,0.5c-0.3,0.1-0.5,0.2-0.8,0.2c-0.4,0-0.8-0.1-1.1-0.3c-0.3-0.2-0.6-0.4-0.7-0.8
           c-0.2-0.3-0.3-0.7-0.3-1.1c0-0.4,0.1-0.8,0.3-1.1c0.2-0.3,0.5-0.6,0.8-0.8C94.2,157.3,94.6,157.2,95,157.2z M95,158.3
           c-0.2,0-0.4,0.1-0.6,0.2c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.2-0.2,0.4-0.2,0.6c0,0.2,0.1,0.4,0.2,0.6c0.1,0.2,0.2,0.3,0.4,0.4
           c0.2,0.1,0.4,0.2,0.6,0.2s0.4-0.1,0.6-0.2c0.2-0.1,0.3-0.2,0.4-0.4c0.1-0.2,0.2-0.4,0.2-0.6c0-0.2-0.1-0.4-0.2-0.6
           c-0.1-0.2-0.2-0.3-0.4-0.4C95.4,158.3,95.2,158.3,95,158.3z" />
            </g>
            <g id="original-price">
              <path class="browse-st15"
                d="M85.1,154.8c-0.3,0-0.5-0.1-0.8-0.2c-0.2-0.1-0.4-0.3-0.5-0.4c-0.1-0.2-0.2-0.4-0.3-0.7l0.7-0.1
           c0.1,0.2,0.2,0.4,0.3,0.5s0.4,0.2,0.6,0.2c0.2,0,0.4-0.1,0.6-0.2c0.1-0.1,0.2-0.2,0.2-0.4c0-0.1,0-0.2-0.1-0.3
           c-0.1-0.1-0.2-0.1-0.3-0.2l-1-0.3c-0.6-0.2-0.8-0.5-0.8-1c0-0.2,0.1-0.4,0.2-0.6c0.1-0.2,0.3-0.3,0.5-0.4
           c0.2-0.1,0.5-0.1,0.7-0.1c0.3,0,0.5,0,0.7,0.1c0.2,0.1,0.4,0.2,0.5,0.4c0.1,0.2,0.2,0.4,0.3,0.6l-0.7,0.1c0-0.1-0.1-0.2-0.2-0.3
           c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1-0.1-0.2-0.1-0.4-0.1c-0.1,0-0.3,0-0.4,0.1c-0.1,0-0.2,0.1-0.3,0.2c-0.1,0.1-0.1,0.2-0.1,0.3
           c0,0.1,0,0.2,0.1,0.3c0.1,0.1,0.2,0.1,0.4,0.2l0.7,0.2c0.3,0.1,0.6,0.2,0.7,0.4c0.2,0.2,0.2,0.4,0.2,0.7c0,0.2-0.1,0.5-0.2,0.7
           c-0.1,0.2-0.3,0.3-0.5,0.4C85.6,154.7,85.4,154.8,85.1,154.8z M84.7,150.8v-0.7h0.7v0.7H84.7z M84.7,155.2v-0.7h0.7v0.7H84.7z" />
              <path class="browse-st15" d="M88.5,154.8c-0.3,0-0.5-0.1-0.7-0.2c-0.2-0.1-0.4-0.3-0.5-0.5c-0.1-0.2-0.2-0.5-0.2-0.8v-1.2
           c0-0.3,0.1-0.6,0.2-0.8c0.1-0.2,0.3-0.4,0.5-0.5s0.5-0.2,0.8-0.2c0.2,0,0.4,0,0.6,0.1c0.2,0.1,0.3,0.2,0.5,0.3l-0.5,0.5
           c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1,0-0.2-0.1-0.3-0.1c-0.2,0-0.3,0-0.4,0.1c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.1,0.2-0.1,0.4v0.7
           l-0.1-0.1c0.1-0.1,0.3-0.2,0.4-0.3c0.2-0.1,0.3-0.1,0.5-0.1c0.3,0,0.5,0.1,0.7,0.2c0.2,0.1,0.3,0.3,0.5,0.5
           c0.1,0.2,0.2,0.4,0.2,0.7c0,0.3-0.1,0.5-0.2,0.7c-0.1,0.2-0.3,0.4-0.5,0.5C89,154.7,88.8,154.8,88.5,154.8z M88.5,154.1
           c0.1,0,0.2,0,0.4-0.1c0.1-0.1,0.2-0.1,0.3-0.3c0.1-0.1,0.1-0.2,0.1-0.4c0-0.1,0-0.2-0.1-0.4c-0.1-0.1-0.1-0.2-0.3-0.3
           c-0.1-0.1-0.2-0.1-0.4-0.1c-0.1,0-0.2,0-0.4,0.1c-0.1,0.1-0.2,0.1-0.3,0.3c-0.1,0.1-0.1,0.2-0.1,0.4c0,0.1,0,0.2,0.1,0.3
           c0.1,0.1,0.1,0.2,0.3,0.3C88.3,154.1,88.4,154.1,88.5,154.1z" />
              <path class="browse-st15" d="M91.8,150.6c0.3,0,0.5,0.1,0.7,0.2c0.2,0.1,0.4,0.3,0.5,0.5c0.1,0.2,0.2,0.5,0.2,0.8v1.2
           c0,0.3-0.1,0.6-0.2,0.8c-0.1,0.2-0.3,0.4-0.5,0.5s-0.5,0.2-0.8,0.2c-0.2,0-0.4,0-0.6-0.1c-0.2-0.1-0.3-0.2-0.5-0.3l0.5-0.5
           c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0,0.2,0.1,0.3,0.1c0.2,0,0.3,0,0.4-0.1c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.1-0.2,0.1-0.4v-0.7
           l0.1,0.1c-0.1,0.1-0.3,0.2-0.4,0.3c-0.2,0.1-0.3,0.1-0.5,0.1c-0.3,0-0.5-0.1-0.7-0.2c-0.2-0.1-0.3-0.3-0.5-0.5
           c-0.1-0.2-0.2-0.4-0.2-0.7c0-0.3,0.1-0.5,0.2-0.7c0.1-0.2,0.3-0.4,0.5-0.5C91.3,150.7,91.5,150.6,91.8,150.6z M91.8,151.2
           c-0.1,0-0.2,0-0.4,0.1c-0.1,0.1-0.2,0.1-0.3,0.3c-0.1,0.1-0.1,0.2-0.1,0.4c0,0.1,0,0.2,0.1,0.4c0.1,0.1,0.1,0.2,0.3,0.3
           c0.1,0.1,0.2,0.1,0.4,0.1c0.1,0,0.2,0,0.4-0.1c0.1-0.1,0.2-0.1,0.3-0.3c0.1-0.1,0.1-0.2,0.1-0.4c0-0.1,0-0.2-0.1-0.3
           c-0.1-0.1-0.1-0.2-0.3-0.3C92,151.3,91.9,151.2,91.8,151.2z" />
              <path class="browse-st15" d="M95.2,150.6c0.3,0,0.5,0.1,0.7,0.2c0.2,0.1,0.4,0.3,0.5,0.5c0.1,0.2,0.2,0.5,0.2,0.8v1.2
           c0,0.3-0.1,0.6-0.2,0.8c-0.1,0.2-0.3,0.4-0.5,0.5c-0.2,0.1-0.5,0.2-0.8,0.2c-0.2,0-0.4,0-0.6-0.1c-0.2-0.1-0.3-0.2-0.5-0.3
           l0.5-0.5c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0,0.2,0.1,0.3,0.1c0.2,0,0.3,0,0.4-0.1c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.1-0.2,0.1-0.4
           v-0.7l0.1,0.1c-0.1,0.1-0.3,0.2-0.4,0.3c-0.2,0.1-0.3,0.1-0.5,0.1c-0.3,0-0.5-0.1-0.7-0.2c-0.2-0.1-0.3-0.3-0.5-0.5
           c-0.1-0.2-0.2-0.4-0.2-0.7c0-0.3,0.1-0.5,0.2-0.7c0.1-0.2,0.3-0.4,0.5-0.5C94.7,150.7,95,150.6,95.2,150.6z M95.2,151.2
           c-0.1,0-0.2,0-0.4,0.1c-0.1,0.1-0.2,0.1-0.3,0.3c-0.1,0.1-0.1,0.2-0.1,0.4c0,0.1,0,0.2,0.1,0.4c0.1,0.1,0.1,0.2,0.3,0.3
           c0.1,0.1,0.2,0.1,0.4,0.1c0.1,0,0.2,0,0.4-0.1c0.1-0.1,0.2-0.1,0.3-0.3c0.1-0.1,0.1-0.2,0.1-0.4c0-0.1,0-0.2-0.1-0.3
           c-0.1-0.1-0.1-0.2-0.3-0.3C95.5,151.3,95.4,151.2,95.2,151.2z" />
            </g>
            <rect id="discount-line" x="83.2" y="152.1" class="browse-st13" width="13.8" height="0.7" />
          </g>
        </g>
      </g>
      <g id="fingers">
        <path class="browse-st20" d="M106.7,102.2c0.2,2.1-0.7,5.3-2.1,8.2c-0.6,1.1-1.5,2.1-2.3,3c-0.9,1.1-1.6,2.1-2,2.9
     c-1.3,2.7-1.6,5.8-0.7,8.6c0.5,1.6,1.4,2.9,2.6,3.4c0.1,0,0.1,0,0.2,0.1c-0.1,0.1-0.1,0.1-0.2,0.2c-3.3,3.5-5.8,7.1-5.5,10.8
     c0.5,2.6,1.6,4.5,3.3,5.6c-0.4,2.3-0.4,4.5,0.1,6.5c0.2,0.8,0.6,1.5,1.1,2c0.3,0.3,0.7,0.5,1,0.6c0.7,0.3,1.4,0.4,2.3,0.4
     c0.4,0,0.8-0.1,1.2-0.2c2.4-0.4,4.5-1.7,6.2-3.4c2-2,3.3-4.3,2.9-7.2c-0.2-2.3-1.3-3.5-2.9-4.4c3.3-2.8,4.1-8.1,4.1-10.1
     c-0.1-2-1.5-4.1-3.5-4.9c3.4-3.8,4.7-7.9,3.5-12.5C114.5,107.5,111.7,104.1,106.7,102.2z" />
        <path class="browse-st0" d="M107.7,102.5c2.7,1.3,1.1,4.4-1.1,7.4c-0.7,1-1.5,2.1-2.3,3c-0.9,1.1-1.6,2.1-2,2.9c-1.3,2.7-1.6,5.8-0.7,8.6
     c0.5,1.6,1.4,2.9,2.6,3.4c0.1,0,0.1,0,0.2,0.1c-0.1,0.1-0.1,0.1-0.2,0.2c-3.3,3.5-5.8,7.1-5.5,10.8c0.5,2.6,1.6,4.5,3.3,5.6
     c-0.4,2.3-0.4,4.5,0.1,6.5c0.2,0.8,0.6,1.5,1.1,2c0.3,0.3,0.7,0.5,1,0.6c0.7,0.3,1.4,0.4,2.3,0.4c0.4,0,0.8-0.1,1.2-0.2
     c2.4-0.4,4.5-1.7,6.2-3.4c2-2,3.3-4.3,2.9-7.2c-0.2-2.3-1.3-3.5-2.9-4.4c3.3-2.8,4.1-8.1,4.1-10.1c-0.1-2-1.5-4.1-3.5-4.9
     c3.4-3.8,4.7-7.9,3.5-12.5C116.6,107.2,112.8,104.4,107.7,102.5z" />
        <path class="browse-st1" d="M112.8,115.7c1,1,1.6,2.5,1.8,4.3c0.1,0.7-0.1,1.3-0.4,1.9c-0.9,1.4-2,2.4-3.2,3.1c-1.1,0.7-2.6,0.5-3.5-0.5
     c-1-1.1-1.7-2.5-2.1-4.1c-0.1-0.5-0.1-1,0.1-1.5c0.8-2.5,2.6-3.7,5.2-3.9C111.4,114.9,112.2,115.2,112.8,115.7z" />
        <path class="browse-st1" d="M111.8,132c1,1,1.6,2.5,1.8,4.3c0.1,0.7-0.1,1.3-0.4,1.9c-0.9,1.4-2,2.4-3.2,3.1c-1.1,0.7-2.6,0.5-3.5-0.5
     c-1-1.1-1.7-2.5-2.1-4.1c-0.1-0.5-0.1-1,0.1-1.5c0.8-2.5,2.6-3.7,5.2-3.9C110.5,131.2,111.3,131.5,111.8,132z" />
        <path class="browse-st1" d="M107,145.1c0.9-1,2.6-1.8,4.6-2.6c0.2-0.1,0.4-0.2,0.6,0c1.3,1,1.9,2.6,1.6,5.1c-0.1,0.7-0.4,1.4-1,1.9
     c-1,0.9-2,1.6-2.8,2c-0.3,0.1-0.7,0.1-0.9-0.1c-1.5-1.2-2.4-3-2.4-5.4C106.6,145.6,106.8,145.4,107,145.1z" />
      </g>
      <g id="text-bot">
        <path class="browse-st21" d="M25.7,26.3c1.3,0.8,2.2,2.1,2.6,3.6l-4.4,0.4c-0.3-0.4-0.6-0.7-1.1-0.9c-0.5-0.2-1.1-0.3-1.6-0.2
     c-0.9,0-1.8,0.5-2.4,1.3c-0.6,0.8-0.8,1.8-0.7,2.8c0,1.1,0.5,2.2,1.2,2.9c0.8,0.6,1.9,0.9,2.9,0.7c0.7,0,1.3-0.3,1.8-0.7
     c0.5-0.4,0.9-1,1.1-1.6L21.1,35l-0.3-3l7.7-0.7l0.4,4.2c-0.4,1.3-1.2,2.5-2.3,3.5c-1.2,1.1-2.8,1.7-4.4,1.7c-1.4,0.2-2.8,0-4.1-0.6
     c-1.2-0.5-2.2-1.4-2.9-2.5c-0.8-1.2-1.2-2.5-1.3-3.9c-0.2-1.4,0-2.8,0.6-4.1c0.5-1.2,1.3-2.2,2.4-2.9c1.2-0.8,2.5-1.2,3.9-1.3
     C22.5,25.1,24.2,25.4,25.7,26.3z" />
        <path class="browse-st21" d="M38.9,39.1l-3.6-5.3l-0.4,0l0.5,5.6l-4.2,0.4l-1.4-15.2l6.7-0.6c1.1-0.1,2.1,0,3.2,0.4
     c0.8,0.3,1.6,0.9,2.1,1.6c0.5,0.7,0.8,1.6,0.9,2.5c0.1,1-0.1,2-0.6,2.8c-0.6,0.9-1.4,1.5-2.4,1.9l4,5.6L38.9,39.1z M34.7,31
     l2.1-0.2c1.2-0.1,1.7-0.7,1.6-1.7c0-0.4-0.2-0.9-0.5-1.1c-0.4-0.3-0.9-0.4-1.4-0.3l-2.1,0.2L34.7,31z" />
        <path class="browse-st21" d="M48.4,26.4l0.2,2.5l4.9-0.4l0.3,3.2l-4.9,0.4l0.3,2.7l5.6-0.5l0.3,3.4l-9.8,0.9l-1.3-15.2l9.8-0.9l0.3,3.4
     L48.4,26.4z" />
        <path class="browse-st21" d="M60.1,25.3l0.2,2.5l4.9-0.4l0.3,3.2L60.6,31l0.3,2.7l5.6-0.5l0.3,3.4l-9.8,0.9l-1.4-15.2l9.8-0.9l0.3,3.4
     L60.1,25.3z" />
        <path class="browse-st21" d="M77.8,20.9c1,0.4,2,1,2.7,1.8c0.7,0.9,1.3,1.9,1.6,2.9l-4.4,0.4c-0.3-0.6-0.7-1-1.3-1.3
     c-0.6-0.3-1.2-0.4-1.8-0.3c-0.9,0.1-1.7,0.5-2.2,1.2c-0.5,0.8-0.8,1.9-0.6,2.9c0,1,0.4,2,1.1,2.7c0.6,0.6,1.5,1,2.3,0.8
     c0.6,0,1.2-0.3,1.7-0.7c0.5-0.4,0.8-0.9,1-1.5l4.4-0.4c-0.1,1.7-0.9,3.2-2,4.4c-1.3,1.2-3,1.9-4.7,2c-1.4,0.2-2.8-0.1-4-0.6
     c-1.2-0.5-2.2-1.4-2.8-2.5c-0.7-1.2-1.2-2.5-1.3-3.9c-0.1-1.4,0-2.8,0.6-4.1c0.5-1.2,1.3-2.2,2.4-2.9c1.1-0.8,2.5-1.2,3.8-1.3
     C75.5,20.4,76.7,20.5,77.8,20.9z" />
        <path class="browse-st21" d="M88,22.8l0.2,2.5l4.9-0.4l0.3,3.2l-4.9,0.4l0.3,2.7l5.6-0.5l0.3,3.4L84.8,35l-1.4-15.2l9.8-0.9l0.3,3.4
     L88,22.8z" />
        <path class="browse-st21"
          d="M100.9,17.4l0.4,10.4l-3.6,0.3l-1.4-10.3L100.9,17.4z M101.8,29.3l0.4,4.1l-4.3,0.4l-0.4-4.1L101.8,29.3z" />
      </g>
      <g id="text-top">
        <path class="browse-st21" d="M12.2,15.8c0.5,0.2,1,0.6,1.3,1.1c0.7,1.1,0.8,2.4,0.3,3.6c-0.2,0.5-0.6,1-1.1,1.4c-1,0.7-2.3,0.8-3.5,0.3
     c-0.5-0.3-1-0.6-1.3-1.1c-0.7-1.1-0.8-2.4-0.3-3.6c0.2-0.5,0.6-1,1.1-1.4C9.8,15.4,11.1,15.2,12.2,15.8z M9.3,17.6
     c-0.3,0.4-0.4,1-0.3,1.5c0,0.5,0.2,1,0.6,1.4c0.8,0.6,1.9,0.5,2.6-0.2c0.3-0.4,0.4-1,0.4-1.5c0-0.5-0.2-1-0.6-1.4
     c-0.4-0.3-0.9-0.5-1.3-0.4C10.1,17,9.6,17.2,9.3,17.6L9.3,17.6z" />
        <path class="browse-st21"
          d="M21.5,21.4l-1.7,0.1l-3.1-3.9l0.4,4.2L15.4,22l-0.6-6.8l1.7-0.1l3.1,4l-0.4-4.2l1.6-0.1L21.5,21.4z" />
        <path class="browse-st21" d="M23.7,15.7l0.1,1.4l2.3-0.2l0.1,1.2L24,18.4l0.1,1.5l2.6-0.2l0.1,1.3l-4.2,0.4L22,14.5l4.2-0.4l0.1,1.3
     L23.7,15.7z" />
        <path class="browse-st21" d="M34.4,14c0.6,0.4,1.1,1,1.3,1.8l-1.7,0.2c-0.1-0.3-0.4-0.5-0.7-0.7c-0.3-0.2-0.6-0.2-1-0.2
     c-0.5,0-0.9,0.3-1.1,0.6c-0.3,0.4-0.4,1-0.3,1.5c0,0.5,0.2,1,0.6,1.4c0.3,0.3,0.8,0.5,1.2,0.4c0.3,0,0.7-0.1,0.9-0.4
     c0.3-0.2,0.4-0.5,0.5-0.8l1.7-0.2c-0.1,0.7-0.4,1.4-0.9,1.9c-0.6,0.5-1.3,0.8-2.1,0.9c-0.6,0.1-1.2,0-1.8-0.3
     c-0.5-0.2-1-0.6-1.3-1.1c-0.3-0.5-0.5-1.1-0.6-1.8c-0.1-0.6,0-1.3,0.3-1.8c0.2-0.5,0.6-1,1-1.3C31.7,13.4,33.2,13.3,34.4,14
     L34.4,14z" />
        <path class="browse-st21" d="M38.5,18.6l2.2-0.2l0.1,1.3L37,20l-0.6-6.8l1.7-0.1L38.5,18.6z" />
        <path class="browse-st21" d="M42.6,12.7l0.6,6.8l-1.6,0.1L41,12.8L42.6,12.7z" />
        <path class="browse-st21" d="M49.1,12.7c0.6,0.4,1.1,1,1.3,1.8l-1.7,0.2c-0.1-0.3-0.4-0.5-0.7-0.7c-0.3-0.2-0.6-0.2-1-0.2
     c-0.5,0-0.9,0.3-1.1,0.6c-0.3,0.4-0.4,1-0.3,1.5c0,0.5,0.2,1,0.6,1.3c0.3,0.3,0.8,0.5,1.2,0.4c0.3,0,0.7-0.1,0.9-0.4
     c0.2-0.2,0.4-0.5,0.5-0.8l1.7-0.1c-0.1,0.7-0.4,1.4-0.9,1.9c-0.6,0.5-1.3,0.8-2.1,0.9c-0.6,0.1-1.2,0-1.8-0.3
     c-0.5-0.2-1-0.6-1.3-1.1c-0.3-0.5-0.5-1.1-0.6-1.8c-0.1-0.6,0-1.3,0.3-1.9c0.2-0.5,0.6-1,1-1.3c0.5-0.3,1.1-0.5,1.7-0.6
     C47.6,12.1,48.4,12.3,49.1,12.7z" />
        <path class="browse-st21"
          d="M54.5,15l3.1,3.2l-2,0.2L53,15.5l0.3,3l-1.6,0.1L51,11.9l1.6-0.1l0.3,3l2-3.2l2-0.2L54.5,15z" />
        <path class="browse-st21"
          d="M64.9,11.3c0.6,0.4,1.1,1,1.3,1.7l-1.7,0.2c-0.1-0.3-0.4-0.5-0.7-0.7c-0.3-0.2-0.6-0.2-1-0.2
     c-0.4,0-0.9,0.3-1.1,0.6c-0.3,0.4-0.4,1-0.3,1.5c0,0.5,0.2,1,0.6,1.4c0.3,0.3,0.8,0.5,1.2,0.4c0.3,0,0.7-0.1,0.9-0.4
     c0.2-0.2,0.4-0.5,0.5-0.8l1.7-0.2c-0.1,0.7-0.4,1.4-0.9,1.9c-1.1,0.9-2.6,1.2-3.9,0.6c-0.5-0.2-1-0.6-1.3-1.1
     c-0.3-0.5-0.5-1.1-0.6-1.8c-0.1-0.6,0-1.3,0.3-1.8c0.2-0.5,0.6-1,1-1.3c0.5-0.3,1.1-0.6,1.7-0.6C63.5,10.7,64.3,10.9,64.9,11.3z" />
        <path class="browse-st21" d="M69,15.9l2.2-0.2l0.1,1.3l-3.8,0.3l-0.6-6.8l1.6-0.1L69,15.9z" />
        <path class="browse-st21"
          d="M76.5,10c0.5,0.2,1,0.6,1.3,1.1c0.4,0.5,0.6,1.1,0.6,1.8c0.1,0.6,0,1.3-0.3,1.8c-0.2,0.5-0.6,1-1.1,1.4
     c-1,0.7-2.3,0.8-3.5,0.3c-0.5-0.2-1-0.6-1.4-1.1c-0.4-0.5-0.6-1.1-0.6-1.8c-0.1-0.6,0-1.3,0.3-1.8c0.2-0.5,0.6-1,1.1-1.4
     C74,9.6,75.3,9.5,76.5,10L76.5,10z M73.6,11.8c-0.3,0.4-0.4,1-0.4,1.5c0,0.5,0.2,1,0.6,1.4c0.4,0.3,0.9,0.5,1.3,0.4
     c0.5,0,0.9-0.3,1.2-0.6c0.3-0.4,0.4-1,0.4-1.5c0-0.5-0.2-1-0.6-1.4c-0.4-0.3-0.8-0.5-1.3-0.4C74.4,11.2,73.9,11.4,73.6,11.8z" />
        <path class="browse-st21"
          d="M84.2,14.9c-0.2,0.3-0.4,0.6-0.7,0.8c-0.4,0.2-0.8,0.4-1.3,0.4c-0.7,0.1-1.4,0-1.9-0.4
     c-0.6-0.3-0.9-0.9-1-1.5l1.8-0.2c0,0.2,0.1,0.4,0.3,0.6c0.2,0.1,0.4,0.2,0.6,0.2c0.2,0,0.4-0.1,0.5-0.2c0.2-0.3,0.2-0.7-0.1-0.9
     c-0.1-0.1-0.3-0.2-0.4-0.3c-0.2-0.1-0.4-0.1-0.7-0.2c-0.4-0.1-0.7-0.2-1.1-0.3c-0.3-0.1-0.5-0.3-0.7-0.6c-0.2-0.3-0.4-0.7-0.4-1
     c0-0.4,0.1-0.7,0.3-1c0.2-0.3,0.5-0.6,0.8-0.7c0.4-0.2,0.8-0.3,1.2-0.3c0.6-0.1,1.3,0,1.9,0.4c0.5,0.3,0.8,0.8,0.9,1.4L82.2,11
     c0-0.2-0.1-0.4-0.3-0.5c-0.3-0.2-0.7-0.2-1,0c-0.1,0.1-0.2,0.3-0.1,0.5c0,0.2,0.1,0.3,0.2,0.4c0.1,0.1,0.3,0.2,0.4,0.2
     c0.2,0.1,0.4,0.1,0.7,0.2c0.4,0.1,0.7,0.2,1.1,0.3c0.3,0.1,0.5,0.3,0.7,0.6c0.2,0.3,0.4,0.7,0.4,1C84.4,14.2,84.4,14.5,84.2,14.9z" />
        <path class="browse-st21" d="M86.7,10l0.1,1.4l2.3-0.2l0.1,1.2l-2.3,0.2l0.1,1.5l2.6-0.2l0.1,1.3l-4.2,0.4l-0.6-6.8l4.2-0.4l0.1,1.3
     L86.7,10z" />
        <path class="browse-st21" d="M94.2,14.9l-1.7-2.4h-0.4l0.2,2.6l-1.6,0.1L90,8.4l2.8-0.3c0.5-0.1,0.9,0,1.4,0.2c0.4,0.1,0.7,0.4,0.9,0.7
     c0.2,0.3,0.3,0.7,0.3,1.1c0.1,0.5-0.1,0.9-0.3,1.3c-0.3,0.4-0.7,0.7-1.1,0.8l1.9,2.5L94.2,14.9z M92,11.3l1-0.1
     c0.3,0,0.5-0.1,0.7-0.3c0.2-0.2,0.2-0.4,0.2-0.7c0-0.2-0.1-0.5-0.3-0.6c-0.2-0.2-0.5-0.2-0.7-0.2l-1,0.1L92,11.3z" />
        <path class="browse-st21" d="M103,7.2l0.1,1.3l-1.9,0.2l0.5,5.5l-1.7,0.2l-0.5-5.5L97.8,9l-0.1-1.3L103,7.2z" />
        <path class="browse-st21" d="M108.7,7.1c0.5,0.3,1,0.7,1.3,1.2c0.4,0.5,0.6,1.1,0.6,1.8c0.1,0.6,0,1.3-0.3,1.8c-0.2,0.5-0.6,1-1.1,1.4
     c-1,0.7-2.3,0.8-3.5,0.3c-0.5-0.3-1-0.6-1.3-1.1c-0.4-0.5-0.6-1.1-0.6-1.8c-0.1-0.6,0-1.3,0.3-1.8c0.2-0.6,0.6-1,1.1-1.4
     c0.5-0.3,1.1-0.6,1.7-0.6C107.5,6.7,108.1,6.8,108.7,7.1z M105.8,9c-0.3,0.4-0.4,1-0.3,1.5c0,0.5,0.2,1,0.6,1.4
     c0.8,0.6,1.9,0.5,2.6-0.2c0.3-0.4,0.4-1,0.4-1.5c0-0.5-0.2-1-0.6-1.4C107.6,8.1,106.5,8.2,105.8,9z" />
      </g>
    </svg>

  </div>
  <div class="login__section">

    <p class="login__note">You will receive a notification when a host replies to your request with a special
      offer.
    </p>
    <!--<span class="alternativeSignUp">We require you to sign up in order to connect you to our hosts every time you submit a new request.</span>-->
    <div class="social">
      <button (click)="socialSignIn('google')" class="social__button"><img class="social__icon"
          src="../../../../../assets/img/icons/google_icon.svg" alt="Google Logo"><span class="social__text">Connect
          with
          Google</span></button>
      <button (click)="socialSignIn('facebook')" class="social__button"><img class="social__icon"
          src="../../../../../assets/img/icons/facebook_icon.svg" alt="Facebook Logo"><span class="social__text">Connect
          with
          Facebook</span></button>
    </div>
    <span class="alternativeSignUp">or sign up via</span>
    <div class="login__container">
      <div class="credsContainer">
        <div class="emailInput">
          <input autocomplete="on" [(ngModel)]="userEmail" type="email" placeholder="Email">
        </div>
        <hr>
        <div class="passwdInput">
          <input autocomplete="on" id="pass" [(ngModel)]="userPasswd" type="password" placeholder="Password">
        </div>
        <hr>
        <div class="passwdInput">
          <input id="passc" [(ngModel)]="userPasswdConfirm" type="password" placeholder="Confirm Password">
          <div class="showPasswordContainer">
            <span>Show</span><input type="checkbox" class="showPassword" (click)="showPassword()">
          </div>
        </div>
        <mat-password-strength #passwordComponent [password]="userPasswd" [enableSpecialCharRule]="false"
          [enableLengthRule]="true" [enableLowerCaseLetterRule]="false">
        </mat-password-strength>
        <mat-password-strength-info *ngIf="showDetailsPasswd" [passwordComponent]="passwordComponent"
          [minCharsCriteriaMsg]="minCharsCriteriaMsg" [upperCaseCriteriaMsg]="upperCaseCriteriaMsg"
          [digitsCriteriaMsg]="digitsCriteriaMsg">
        </mat-password-strength-info>
        <button id="button__signup" class="button__login" type="submit" (click)="signUpStableInit()">Sign
          up</button>
      </div>
    </div>
    <div class="forgotPass">
      <p><a (click)="forgotBtn()">Forgot your password?</a></p>
    </div>
    <p class="ahaLogin">Already have an account? <a (click)="ahaBtn()">Login</a></p>
    <div id="privacyMsg">
      <p>We respect your privacy and protect it very seriously.</p>
    </div>

    <div class="note">
      <div class="note__container">
        <ul class="note__list">
          <li class="list__icon list__item">You will never receive spam or ads.</li>
          <li class="list__icon list__item">We never share your information.</li>
          <li class="list__icon list__item">Hosts cannot see your email.</li>
        </ul>
      </div>
    </div>
  </div>
</div>



<!-- FORGOT PASSWORD PAGE -->
<div *ngIf="isForgotPasswd" [ngClass]="deviceType === 'mobile' ? 'loginContainer' : 'loginContainerDesktop'">
  <img class="forgot__img" src="../../../../../assets/img/illustration_forgot-pass.svg"
    alt="Super heroine holding a giant key">
  <div class="login__section">
    <div class="login__container">
      <div class="credsContainer">
        <div class="emailInput">
          <input [(ngModel)]="userEmailfg" type="email" placeholder="Email">
        </div>
        <hr>
        <button class="button__login" (click)="submitReset()">Reset Password</button>
      </div>
    </div>
    <p *ngIf="deviceType === 'desktop'" class="ahaLogin">Don't have an account? <a (click)="signUpRBtn()">Sign Up</a></p>
    <div id="privacyMsg">
      <p>We respect your privacy and protect it very seriously.</p>
    </div>
  </div>
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white;">Loading...</p>
</ngx-spinner>